export interface GridOperator {
  id: string;
  name: string;
}

function dedupeOperators(operators: GridOperator[]): GridOperator[] {
  const foundNames: Record<string, 1> = {};
  const result: GridOperator[] = [];
  for (let i = 0; i < operators.length; i += 1) {
    const { name } = operators[i];
    if (foundNames[name] !== 1) {
      result.push(operators[i]);
      foundNames[name] = 1;
    }
  }
  return result;
}

const gridOperatorsAt = [
  'Alfenzwerke Elektrizitätserzugung GmbH',
  'Anton Kittel Mühle Plaika GmbH',
  'BAD GLEICHENBERGER ENERGIE GmbH',
  'E-Werk Stubenberg',
  'E-Genossenschaft Laintal Reg. Gen.m.b.H',
  'E-Werk der Marktgemeinde Unzmarkt-Frauenburg',
  'E-Werk Dietrichschlag eGen',
  'E-Werk Ebner GesmbH',
  'E-Werk Gleinstätten GmbH',
  'E-Werk Gröbming KG',
  'E-Werk Gösting Stromversorgungs GmbH',
  'E-Werk Kötschach',
  'E-Werk Neudau, Kottulinsky KG',
  'E-Werk Ranklleiten',
  'E-Werk Redlmühle',
  'E-Werk Sarmingstein',
  'E-Werk Schwaighofer GmbH',
  'E-Werk SIGL GMBH & Co KG',
  'E-Werk Stadler GmbH',
  'E-Werk Tassotti',
  'E-Werk Wüster KG',
  'E-Werk Frastanz',
  'Ebner Strom Gmbh',
  'Elektrizitätswerk Bad Hofgastein Ges.m.b.H',
  'Elektrizitätswerk Clam, Carl-Philip Clam-Martinic e.U.',
  'Elektrizitätswerk der Gemeinde Gries am Brenner',
  'Elektrizitätswerk der Gemeinde Mürzsteg',
  'Elektrizitätswerk der Gemeinde Schattwald',
  'Elektrizitätswerk der Stadtgemeinde Kindberg',
  'Elektrizitätswerk Fernitz Ing. Franz Purkarthofer GmbH & Co KG',
  'Elektrizitätswerk Johann Dandler GmbH&CoKG',
  'Elektrizitätswerk Mariahof GmbH',
  'Elektrizitätswerk Mathe',
  'Elektrizitätswerk Perg GmbH',
  'Elektrizitätswerk Prantl GmbH&CoKG',
  'Elektrizitätswerk Pölsler',
  'Elektrizitätswerk Reinisch',
  'Elektrizitätswerk Winkler GmbH',
  'Elektrizitätswerk Bad Radkersburg GmbH',
  'Elektrizitätswerk Eisenhuber GmbH& Co KG',
  'Elektrizitätswerk Reutte AG',
  'Elektro-Güssing GesmbH',
  'Elektrogenossenschaft Weerberg reg.GenmbH',
  'Elektrowerk Assling reg. Gen. m. b. H.',
  'Elektrowerk Max Hechenblaikner',
  'Elektrowerk Schöder GmbH',
  'Elektrowerkgenossenschaft Hopfgarten I. Def. reg. Gen. m. b. H.',
  'Energie Graz GmbH & Co KG',
  'Energie Klagenfurt GmbH',
  'Energie Ried GmbH',
  'Energie- und Wirtschaftsbetriebe der Gemeinde St. Anton GmbH',
  'Energienetze Steiermark GmbH',
  'Energieversorgung Kleinwalsertal',
  'Energieversorgungs GmbH',
  'Energieversorgungsunternehmen der Florian Lugitsch Gruppe GmbH',
  'Envesta Energie- & Dienstleistungs GesmbH GesmbH',
  'EVU der Marktgemeinde Eibiswald',
  'EVU der Marktgemeinde Niklasdorf',
  'EVU der Stadtgemeinde Mureck',
  'EVU-Braunstein',
  'Feistritzthaler Elektrizitätswerk egen',
  'Feistritztwerke-STEWEAG GmbH',
  'Forstverwaltung Neuhaus Alpl Kraftwerksbetrieb',
  'Gemeindewerke Kematen',
  'Gertraud Schafler GmbH.',
  'Getzner, Mutter & Cie',
  'Heinrich Polsterer & Mitgesellschafter GesnbR',
  'Ing. Peter Böhm',
  'Innsbrucker Kommunalbetriebe AG',
  'Joh. Pengg Holding Gesellschaft m.b.H',
  'K. u. F. Drack GmbH & Co KG',
  'KARLSTROM e.U.',
  'Klausbauer Holzindustrie GesmbH & Co K',
  'Kneidinger 1880 GmbH',
  'KNG-Kärnten Netz GmbH',
  'Kommunalbetriebe Hopfgarten GmbH',
  'Kommunalbetriebe Rinn GmbH',
  'Kraftwerk Glatzing-Rüstorf (KWG)',
  'Kraftwerk Haim KG',
  "Kupelwieser'sche Forstverwaltung Seehof",
  'Lechner August KG',
  'Licht- und Kraftvertrieb der Gemeinde Opponitz',
  'Licht- und Kraftvertrieb der Marktgemeinde Göstling an der Ybbs',
  'Licht- und Kraftvertrieb der Gemeinde Hollenstein an der Ybbs',
  'Lichtgenossenschaft Neukirchen, reg. Gen. m.b.H.',
  'Linz Strom Netz GmbH',
  'Ludwig Polsterer Holding Ges. m. b. H.',
  'Marktgemeinde Neumarkt Versorgungsbetriebsges.mbH',
  'Montafoner Bahn AG',
  'Murauer Stadtwerke GmbH',
  'Netz Burgenland Strom GmbH',
  'Netz Niederösterreich GmbH',
  'Netz Oberösterreich Strom GmbH',
  'P.K. Energieversorgungs GmbH',
  'Reverterasches Elektrizitätswerk',
  'Salzburg Netz GmbH',
  'Schwarz, Wagendorffer & Co Elektrizitätswerk GmbH',
  'Stadtbetriebe Mariazell GmbH',
  'STADTwerke Amstetten',
  'Stadtwerke Bruck an der Mur',
  'Stadtwerke Feldkirch',
  'Stadtwerke Fürstenfeld GmbH',
  'Stadtwerke Hall in Tirol',
  'Stadtwerke Imst',
  'Stadtwerke Judenburg AG',
  'Stadtwerke Kapfenberg GmbH',
  'Stadtwerke Kitzbühel',
  'Stadtwerke Kufstein Gesellschaft m.b.H.',
  'Stadtwerke Köflach',
  'Stadtwerke Mürzzuschlag GmbH',
  'Stadtwerke Schwaz GmbH',
  'Stadtwerke Trofaiach',
  'Stadtwerke Voitsberg',
  'Stadtwerke Wörgl GmbH',
  'Stromnetz Graz GmbH & Co KG',
  'StW Hartberg Energieversorgungs GmbH',
  'Stadtische Betriebe Rottenmann GmbH',
  'TINETZ - Tiroler Netze GmbH',
  'Vorarlberger Energienetze GmbH',
  'Wasserkraft Sölden eGen',
  'Wels Strom GmbH',
  'Wiener Netze GmbH',
].map((operator): GridOperator => ({ id: operator, name: operator }));

export const GRID_OPERATORS_AT: GridOperator[] = dedupeOperators(
  gridOperatorsAt
).toSorted((a, b) => a.name.localeCompare(b.name));

const gridOperatorsDe: GridOperator[] = [
  {
    id: 'SNB982046657236',
    name: '50Hertz Transmission GmbH',
  },
  {
    id: 'SNB939688186686',
    name: 'Abita Energie Otterberg GmbH',
  },
  {
    id: 'SNB969871992015',
    name: 'Albstadtwerke GmbH',
  },
  {
    id: 'SNB926699071292',
    name: 'Albwerk GmbH & Co. KG',
  },
  {
    id: 'SNB926394308747',
    name: 'AllgäuNetz GmbH & Co. KG',
  },
  {
    id: 'SNB931070025696',
    name: 'Alliander Netz Heinsberg GmbH',
  },
  {
    id: 'SNB976890256486',
    name: 'Amprion GmbH',
  },
  {
    id: 'SNB918620072652',
    name: 'ASCANETZ GmbH',
  },
  {
    id: 'SNB911081401368',
    name: 'Aschaffenburger Versorgungs-GmbH',
  },
  {
    id: 'SNB990362338043',
    name: 'Avacon Netz GmbH',
  },
  {
    id: 'SNB967794191157',
    name: 'AVU Netz GmbH',
  },
  {
    id: 'SNB973356062049',
    name: 'Bad Honnef AG',
  },
  {
    id: 'SNB911159111601',
    name: 'BASF Schwarzheide GmbH',
  },
  {
    id: 'SNB963282434775',
    name: 'Bauer Netz GmbH & Co. KG',
  },
  {
    id: 'SNB940352624434',
    name: 'Bayernwerk Netz GmbH',
  },
  {
    id: 'SNB944057190867',
    name: 'BEW Netze GmbH',
  },
  {
    id: 'SNB990174285078',
    name: 'BIGGE ENERGIE GmbH & Co. KG',
  },
  {
    id: 'SNB965774651691',
    name: 'bnNETZE GmbH',
  },
  {
    id: 'SNB918576265276',
    name: 'Bocholter Energie- und Wasserversorgung GmbH',
  },
  {
    id: 'SNB927498960503',
    name: 'Bonn-Netz GmbH',
  },
  {
    id: 'SNB926644622999',
    name: 'Braunschweiger Netz GmbH',
  },
  {
    id: 'SNB910066952147',
    name: 'Brücken-Center Ansbach GmbH',
  },
  {
    id: 'SNB951106903149',
    name: 'BSS Netz- und Service Betriebs GmbH',
  },
  {
    id: 'SNB928184287881',
    name: 'BTT Bauteam Tretzel GmbH',
  },
  {
    id: 'SNB972511582064',
    name: 'Butzbacher Netzbetrieb GmbH & Co. KG',
  },
  {
    id: 'SNB956411704207',
    name: 'C. Ensinger GmbH & Co. KG',
  },
  {
    id: 'SNB955238223991',
    name: 'Celle-Uelzen Netz GmbH',
  },
  {
    id: 'SNB975268997129',
    name: 'Covestro Brunsbüttel Energie GmbH',
  },
  {
    id: 'SNB916672506194',
    name: 'Cramer - Mühle KG',
  },
  {
    id: 'SNB960263813482',
    name: 'DB Energie GmbH',
  },
  {
    id: 'SNB954281375657',
    name: 'Dessauer Stromversorgung GmbH',
  },
  {
    id: 'SNB974556654430',
    name: 'Donau-Stadtwerke Dillingen-Lauingen',
  },
  {
    id: 'SNB981060961299',
    name: 'Dortmunder Netz GmbH',
  },
  {
    id: 'SNB955936286892',
    name: 'Dow Olefinverbund GmbH',
  },
  {
    id: 'SNB980808485264',
    name: 'DREWAG NETZ GmbH',
  },
  {
    id: 'SNB941690671609',
    name: 'E.DIS Netz GmbH',
  },
  {
    id: 'SNB925685357501',
    name: 'e.wa riss Netze GmbH',
  },
  {
    id: 'SNB945502201350',
    name: 'ED Netze GmbH',
  },
  {
    id: 'SNB913768089142',
    name: 'EGC Energie- und Gebäudetechnik Control GmbH & Co. KG',
  },
  {
    id: 'SNB962011640685',
    name: 'EGF EnergieGesellschaft Frankenberg mbH',
  },
  {
    id: 'SNB979557818782',
    name: 'EGT Energie GmbH',
  },
  {
    id: 'SNB928479274794',
    name: 'EHINGER ENERGIE GmbH & Co. KG',
  },
  {
    id: 'SNB943806148289',
    name: 'Eichenmüller GmbH & Co. KG Energieversorgung+Elektrotechnik',
  },
  {
    id: 'SNB945768616967',
    name: 'Eichsfelder Energie- und Wasserversorgungsgesellschaft mbH',
  },
  {
    id: 'SNB973074326355',
    name: 'ELE Verteilnetz GmbH',
  },
  {
    id: 'SNB913085272050',
    name: 'Elektra - Genossenschaft Pinzberg eG',
  },
  {
    id: 'SNB983973032059',
    name: 'Elektra-Genossenschaft Effeltrich eG',
  },
  {
    id: 'SNB985979481190',
    name: 'Elektrizitäts- und Wasserversorgungsgenossenschaft Vagen eG',
  },
  {
    id: 'SNB955447118477',
    name: 'Elektrizitätsgenossenschaft Dirmstein eG',
  },
  {
    id: 'SNB981887803796',
    name: 'Elektrizitätsgenossenschaft Engelsberg eG',
  },
  {
    id: 'SNB984995121813',
    name: 'Elektrizitätsgenossenschaft e.G. Hasbergen',
  },
  {
    id: 'SNB945322307522',
    name: 'Elektrizitätsgenossenschaft Karlstein eG',
  },
  {
    id: 'SNB985498109605',
    name: 'Elektrizitätsgenossenschaft Nordhalben und Umgebung e. G.',
  },
  {
    id: 'SNB931015724646',
    name: 'Elektrizitätsgenossenschaft Oesterweg eG',
  },
  {
    id: 'SNB975801091031',
    name: 'Elektrizitätsgenossenschaft Ohlstadt eG',
  },
  {
    id: 'SNB986403410816',
    name: 'Elektrizitäts-Genossenschaft Rettenberg eG',
  },
  {
    id: 'SNB946086138155',
    name: 'Elektrizitäts-Genossenschaft Röthenbach eG',
  },
  {
    id: 'SNB927462109518',
    name: 'Elektrizitätsgenossenschaft Schlachters e.G.',
  },
  {
    id: 'SNB950882682972',
    name: 'Elektrizitäts-Genossenschaft Schonstett eG',
  },
  {
    id: 'SNB935303204162',
    name: 'Elektrizitäts-Genossenschaft Tacherting-Feichten eG',
  },
  {
    id: 'SNB988606051575',
    name: 'Elektrizitätsgenossenschaft Unterneukirchen eG',
  },
  {
    id: 'SNB930134015819',
    name: 'Elektrizitätsgenossenschaft Vogling & Angrenzer eG',
  },
  {
    id: 'SNB974959002937',
    name: 'Elektrizitätsgenossenschaft Wolkersdorf und Umgebung eG',
  },
  {
    id: 'SNB921631931771',
    name: 'Elektrizitätsnetze Allgäu GmbH',
  },
  {
    id: 'SNB916027833432',
    name: 'Elektrizitätsvereinigung Böbing eG',
  },
  {
    id: 'SNB930558787330',
    name: 'Elektrizitäts-Versorgungs-Genossenschaft Perlesreut eG',
  },
  {
    id: 'SNB987451707521',
    name: 'Elektrizitätswerk Bruchmühlbach-Miesau',
  },
  {
    id: 'SNB918689434309',
    name: 'Elektrizitätswerk Dahner Felsenland',
  },
  {
    id: 'SNB985099151188',
    name: 'Elektrizitätswerk des Kantons Schaffhausen AG',
  },
  {
    id: 'SNB916328839515',
    name: 'Elektrizitätswerk Dießen Stadler GmbH',
  },
  {
    id: 'SNB970340354654',
    name: 'Elektrizitätswerk Georg Grandl e.K.',
  },
  {
    id: 'SNB965998184692',
    name: 'Elektrizitätswerk Goldbach-Hösbach GmbH & Co. KG',
  },
  {
    id: 'SNB972819770477',
    name: 'Heinrich Schirmer e.K.',
  },
  {
    id: 'SNB925558752303',
    name: 'Elektrizitätswerk Hindelang eG',
  },
  {
    id: 'SNB942908692218',
    name: 'Karl Stengle GmbH & Co. KG',
  },
  {
    id: 'SNB952385093224',
    name: 'Elektrizitätswerk Leitlein GmbH & Co. KG',
  },
  {
    id: 'SNB980126228475',
    name: 'Elektrizitätswerk Mainbernheim GmbH',
  },
  {
    id: 'SNB942630156484',
    name: 'TauberEnergie Kuhn, Karl und Andreas Kuhn OHG',
  },
  {
    id: 'SNB936480897581',
    name: 'Elektrizitätswerk Max Peissker',
  },
  {
    id: 'SNB982597073882',
    name: 'Elektrizitätswerk Oberwössen e.G.',
  },
  {
    id: 'SNB929636904400',
    name: 'Elektrizitätswerk Ottenhöfen Moser GmbH & Co. KG',
  },
  {
    id: 'SNB916008519201',
    name: 'Elektrizitäts-Werk Ottersberg',
  },
  {
    id: 'SNB921080203146',
    name: 'Elektrizitätswerk Rohmund GmbH',
  },
  {
    id: 'SNB965123602893',
    name: 'Heinrich N. Clausen GmbH & Co. KG',
  },
  {
    id: 'SNB929383206369',
    name: 'Elektrizitätswerk Simbach GmbH',
  },
  {
    id: 'SNB910882213224',
    name: 'Elektrizitätswerk Stern KG Bad Endorf',
  },
  {
    id: 'SNB928258126528',
    name: 'Elektrizitätswerk Tegernsee Carl Miller KG',
  },
  {
    id: 'SNB917593691679',
    name: 'Elektrizitätswerk Unterwössen Döllerer&Greimel Netz GmbH&Co.KG',
  },
  {
    id: 'SNB945186990991',
    name: 'Elektrizitätswerk Wanfried von Scharfenberg KG',
  },
  {
    id: 'SNB913832420338',
    name: 'Elektrizitätswerk Wennenmühle Schörger KG',
  },
  {
    id: 'SNB988980270319',
    name: 'Elektrizitätswerk Wörth a. d. Donau Rupert Heider & Co. KG',
  },
  {
    id: 'SNB969483935394',
    name: 'Elektrizitätswerke Reutte GmbH & Co. KG',
  },
  {
    id: 'SNB974894111862',
    name: 'Elektrizitätswerke Schönau Netze GmbH',
  },
  {
    id: 'SNB931431136771',
    name: 'Elektroenergieversorgung Cottbus GmbH',
  },
  {
    id: 'SNB913866241817',
    name: 'EMB Energieversorgung Miltenberg- Bürgstadt GmbH & Co. KG',
  },
  {
    id: 'SNB910882710327',
    name: 'EMIS ENERGY GmbH',
  },
  {
    id: 'SNB913563830420',
    name: 'ENA Energienetze Apolda GmbH',
  },
  {
    id: 'SNB952566530197',
    name: 'Mainfrankenpark GmbH',
  },
  {
    id: 'SNB971746988153',
    name: 'enercity Netz GmbH',
  },
  {
    id: 'SNB913289502922',
    name: 'eneREGIO GmbH',
  },
  {
    id: 'SNB976371748981',
    name: 'Energie Calw GmbH',
  },
  {
    id: 'SNB934514392514',
    name: 'Energie- und Wasserversorgung Altenburg GmbH',
  },
  {
    id: 'SNB941042755957',
    name: 'Energie- und Wasserversorgung Bruchsal GmbH',
  },
  {
    id: 'SNB912743424114',
    name: 'Energie- und Wasserversorgung Hamm GmbH',
  },
  {
    id: 'SNB966380208811',
    name: 'Energie- und Wasserversorgung Kirchzarten GmbH',
  },
  {
    id: 'SNB932516649124',
    name: 'Energie- und Wasserversorgung Rheine GmbH',
  },
  {
    id: 'SNB943962034624',
    name: 'Energie- und Wasserwerke Bautzen GmbH Energijowe a Wodowezawody Budysin',
  },
  {
    id: 'SNB936172924014',
    name: 'Energie Waldeck-Frankenberg GmbH',
  },
  {
    id: 'SNB914735995145',
    name: 'Energiegenossenschaft für Wittmund eG',
  },
  {
    id: 'SNB971311555230',
    name: 'EAM Netz (ehem. EnergieNetz Mitte) GmbH',
  },
  {
    id: 'SNB994111700501',
    name: 'Energienetze Bayern GmbH (Stromverteilnetz Germering)',
  },
  {
    id: 'SNB917314328846',
    name: 'Energienetze Berlin GmbH',
  },
  {
    id: 'SNB980055629275',
    name: 'Energienetze Mittelrhein GmbH & Co. KG',
  },
  {
    id: 'SNB915100694458',
    name: 'Energienetze Offenbach GmbH',
  },
  {
    id: 'SNB932549440224',
    name: 'Energiequelle GmbH & Co. Windpark Feldheim 2006 KG',
  },
  {
    id: 'SNB911521002599',
    name: 'EnergieSüdwest Netz GmbH',
  },
  {
    id: 'SNB975176329548',
    name: 'Energieverbund Gierstädt GmbH',
  },
  {
    id: 'SNB940901758313',
    name: 'Energieversorgung A9 Mitte GmbH & Co. KG',
  },
  {
    id: 'SNB913576376151',
    name: 'Energieversorgung Alzenau GmbH',
  },
  {
    id: 'SNB942173666990',
    name: 'Energieversorgung Beckum GmbH & Co. KG',
  },
  {
    id: 'SNB932388577952',
    name: 'Energieversorgung Dahlenburg-Bleckede AG',
  },
  {
    id: 'SNB910995561328',
    name: 'Energieversorgung Filstal GmbH & Co. KG',
  },
  {
    id: 'SNB943915605062',
    name: 'EVG Energieversorgung Gemünden GmbH',
  },
  {
    id: 'SNB915186313908',
    name: 'Energieversorgung Guben GmbH',
  },
  {
    id: 'SNB982934611074',
    name: 'Energieversorgung Halle Netz GmbH',
  },
  {
    id: 'SNB974763887737',
    name: 'Energieversorgung Inselsberg GmbH',
  },
  {
    id: 'SNB925831583235',
    name: 'Energieversorgung Josef Schmid',
  },
  {
    id: 'SNB962013221356',
    name: 'Energieversorgung Klettgau-Rheintal GmbH & Co. KG',
  },
  {
    id: 'SNB965281540327',
    name: 'Energieversorgung Limburg GmbH',
  },
  {
    id: 'SNB991797615686',
    name: 'Energieversorgung Lohr-Karlstadt und Umgebung GmbH & Co. KG',
  },
  {
    id: 'SNB927925826730',
    name: 'Stadtwerke Pirna Energie GmbH',
  },
  {
    id: 'SNB986363918520',
    name: 'Energieversorgung Putzbrunn GmbH & Co. KG',
  },
  {
    id: 'SNB935932937127',
    name: 'Energieversorgung Rottenburg am Neckar GmbH',
  },
  {
    id: 'SNB931930462517',
    name: 'Energieversorgung Rüsselsheim GmbH',
  },
  {
    id: 'SNB911696239035',
    name: 'Energieversorgung Selb-Marktredwitz GmbH',
  },
  {
    id: 'SNB921611512679',
    name: 'Energieversorgung Südbaar GmbH & Co. KG',
  },
  {
    id: 'SNB994749019716',
    name: 'Energieversorgung Sylt GmbH',
  },
  {
    id: 'SNB948468070435',
    name: 'Energieversorgung Titisee-Neustadt GmbH',
  },
  {
    id: 'SNB938624241519',
    name: 'Energieversorgung Trossingen GmbH',
  },
  {
    id: 'SNB974684403535',
    name: 'Energiewerke Zeulenroda GmbH',
  },
  {
    id: 'SNB976379598847',
    name: 'energis-Netzgesellschaft mbH',
  },
  {
    id: 'SNB921319639913',
    name: 'ENERVIE Vernetzt GmbH',
  },
  {
    id: 'SNB956958990736',
    name: 'e-netz Südhessen AG',
  },
  {
    id: 'SNB921629791202',
    name: 'ENGIE Deutschland GmbH',
  },
  {
    id: 'SNB953495670831',
    name: 'EnR Energienetze Rudolstadt GmbH',
  },
  {
    id: 'SNB964092397892',
    name: 'ENRO Ludwigsfelde Netz GmbH',
  },
  {
    id: 'SNB951180867351',
    name: 'ENRW Energieversorgung Rottweil GmbH & Co. KG',
  },
  {
    id: 'SNB968914838013',
    name: 'ENSO Netz GmbH',
  },
  {
    id: 'SNB921626387354',
    name: 'energie- und wassergesellschaft mbh',
  },
  {
    id: 'SNB963792700889',
    name: 'ENWG Energienetze Weimar GmbH & Co. KG',
  },
  {
    id: 'SNB977716315769',
    name: 'enwor - energie & wasser vor ort GmbH',
  },
  {
    id: 'SNB967982606159',
    name: 'Erlanger Stadtwerke AG',
  },
  {
    id: 'SNB988556835096',
    name: 'e-shelter power grid GmbH',
  },
  {
    id: 'SNB929575518928',
    name: 'EUROGATE Technical Services GmbH',
  },
  {
    id: 'SNB989700422711',
    name: 'EVB Netze GmbH',
  },
  {
    id: 'SNB985172238775',
    name: 'EVE Netz GmbH',
  },
  {
    id: 'SNB980449174619',
    name: 'EVI Energieversorgung Hildesheim GmbH & Co. KG',
  },
  {
    id: 'SNB989583209836',
    name: 'EVU der Gemeinde Gochsheim',
  },
  {
    id: 'SNB916617262147',
    name: 'EVU der Ortsgemeinde Rheinzabern',
  },
  {
    id: 'SNB930329896650',
    name: 'EVU Langenpreising',
  },
  {
    id: 'SNB953620313688',
    name: 'EVU Markt Kipfenberg',
  },
  {
    id: 'SNB924535591034',
    name: 'EVU Späth e.K.',
  },
  {
    id: 'SNB945750197795',
    name: 'EVU Weilerbach',
  },
  {
    id: 'SNB934984130722',
    name: 'ewag kamenz Energie und Wasserversorgung Aktiengesellschaft Kamenz',
  },
  {
    id: 'SNB951051725711',
    name: 'EWE NETZ GmbH',
  },
  {
    id: 'SNB940113133601',
    name: 'e-werk Gerolsheim',
  },
  {
    id: 'SNB921550647487',
    name: 'E-Werk Meckenheim/Pfalz',
  },
  {
    id: 'SNB958060904298',
    name: 'E-Werk Rohrdorf Josef Haimmerer',
  },
  {
    id: 'SNB958337664054',
    name: 'E-Werk Rupert Buchauer',
  },
  {
    id: 'SNB978963778161',
    name: 'e-werk Sachsenwald GmbH',
  },
  {
    id: 'SNB927892816017',
    name: 'Elektrizitätswerk S c h w e i g e r  o.H.G',
  },
  {
    id: 'SNB978299965228',
    name: 'E-Werke Haniel Haimhausen OHG',
  },
  {
    id: 'SNB977966674678',
    name: 'EW Geiger GmbH',
  },
  {
    id: 'SNB924747450655',
    name: 'EWR GmbH (Remscheid)',
  },
  {
    id: 'SNB969068596941',
    name: 'EWR Netz GmbH (Worms)',
  },
  {
    id: 'SNB923953358557',
    name: 'EWR Netze GmbH (Lichtenstein-Unterhausen)',
  },
  {
    id: 'SNB936468720238',
    name: 'ew-schmid GmbH',
  },
  {
    id: 'SNB911838879365',
    name: 'ews - Netz GmbH',
  },
  {
    id: 'SNB940297211072',
    name: 'EZV Energie- und Service GmbH & Co. KG Untermain',
  },
  {
    id: 'SNB981597332487',
    name: 'Fährhafen Sassnitz GmbH',
  },
  {
    id: 'SNB991882909515',
    name: 'FairNetz GmbH',
  },
  {
    id: 'SNB944723161733',
    name: 'Feuchter Gemeindewerke GmbH (FGW)',
  },
  {
    id: 'SNB960098459084',
    name: 'FischerStrom KG',
  },
  {
    id: 'SNB914149166902',
    name: 'Fischereihafen-Betriebsgesellschaft mbH',
  },
  {
    id: 'SNB958116260552',
    name: 'Flughafen Düsseldorf GmbH',
  },
  {
    id: 'SNB939548785561',
    name: 'Flughafen Energie & Wasser GmbH',
  },
  {
    id: 'SNB983941449513',
    name: 'Flughafen Hannover-Langenhagen GmbH',
  },
  {
    id: 'SNB971155221315',
    name: 'Flughafen  Köln/Bonn GmbH',
  },
  {
    id: 'SNB919526009605',
    name: 'Flughafen München GmbH',
  },
  {
    id: 'SNB938180557147',
    name: 'Flughafen Nürnberg Energie GmbH',
  },
  {
    id: 'SNB946934291780',
    name: 'Flughafen Stuttgart Energie GmbH',
  },
  {
    id: 'SNB965164398427',
    name: 'Fraport AG',
  },
  {
    id: 'SNB990971435621',
    name: 'Freiberger Stromversorgung GmbH',
  },
  {
    id: 'SNB977384143473',
    name: 'Freisinger Stadtwerke Versorgungs-GmbH',
  },
  {
    id: 'SNB982241851170',
    name: 'Freitaler Stadtwerke',
  },
  {
    id: 'SNB931677334054',
    name: 'Freudenberg Service KG',
  },
  {
    id: 'SNB991381724831',
    name: 'Fürstlich Fugger von Glött´sche Elektrizitätswerk GmbH & Co KG',
  },
  {
    id: 'SNB935318978560',
    name: 'Gammertinger Energie- und Wasserversorgung GmbH',
  },
  {
    id: 'SNB975462731697',
    name: 'Gebr. Heinzelmann Stromhandels- und Vertriebs- GmbH & Co. KG',
  },
  {
    id: 'SNB953422913031',
    name: 'Gebrüder Eirich GmbH & Co. KG',
  },
  {
    id: 'SNB926427521488',
    name: 'Gebrüder Miller, Elektrizitätsversorgung GmbH & Co. KG',
  },
  {
    id: 'SNB961497906636',
    name: 'GELSENWASSER Energienetze GmbH',
  },
  {
    id: 'SNB968325295962',
    name: 'Gemeinde Glattbach',
  },
  {
    id: 'SNB984971042750',
    name: 'Gemeinde Hemhofen',
  },
  {
    id: 'SNB942824437573',
    name: 'Gemeinde Heroldsbach - Stromversorgung -',
  },
  {
    id: 'SNB984338214660',
    name: 'Gemeinde-Elektrizitäts- und Wasserwerk Burtenbach',
  },
  {
    id: 'SNB963653114022',
    name: 'Gemeindewerk Krickenbach c/o Stadtwerke Kaiserslautern ',
  },
  {
    id: 'SNB983344227725',
    name: 'Gemeindewerk Stelzenberg c/o Stadtwerke Kaiserslautern',
  },
  {
    id: 'SNB998167765620',
    name: 'Gemeindewerke Baiersbronn',
  },
  {
    id: 'SNB914092143906',
    name: 'Gemeindewerke Bayerisch Gmain',
  },
  {
    id: 'SNB957268511697',
    name: 'Gemeindewerke Bovenden GmbH & Co. KG',
  },
  {
    id: 'SNB922361841965',
    name: 'Gemeindewerke Budenheim',
  },
  {
    id: 'SNB951232597106',
    name: 'Gemeindewerke Cadolzburg',
  },
  {
    id: 'SNB950724684287',
    name: 'Gemeindewerke Dudenhofen',
  },
  {
    id: 'SNB991410365127',
    name: 'Gemeindewerke Ebersdorf',
  },
  {
    id: 'SNB986931195988',
    name: 'Gemeindewerke Enkenbach-Alsenborn - Elektrizitätswerk',
  },
  {
    id: 'SNB947727983103',
    name: 'Gemeindewerke Frammersbach',
  },
  {
    id: 'SNB954239007623',
    name: 'Gemeindewerke Gangkofen',
  },
  {
    id: 'SNB926937565941',
    name: 'Gemeindewerke Garmisch-Partenkirchen, KU',
  },
  {
    id: 'SNB966216072913',
    name: 'Gemeindewerke Georgensgmünd',
  },
  {
    id: 'SNB993724515038',
    name: 'Gemeindewerke Grefrath GmbH',
  },
  {
    id: 'SNB962736090291',
    name: 'Gemeindewerke Großkrotzenburg GmbH',
  },
  {
    id: 'SNB926559276683',
    name: 'Gemeindewerke Gundelfingen GmbH',
  },
  {
    id: 'SNB928557841498',
    name: 'Gemeindewerke Halstenbek Strom -Erdgas-Wärme-Wasser-Abwasser-Dienstleistung',
  },
  {
    id: 'SNB985189431268',
    name: 'Gemeindewerke Hardt Eigenbetrieb',
  },
  {
    id: 'SNB991400668603',
    name: 'Gemeindewerke Haßloch GmbH',
  },
  {
    id: 'SNB971174411018',
    name: 'Gemeindewerke Heikendorf GmbH',
  },
  {
    id: 'SNB961322866920',
    name: 'Gemeindewerke Herxheim',
  },
  {
    id: 'SNB924819944297',
    name: 'Gemeindewerke Holzkirchen GmbH',
  },
  {
    id: 'SNB926163456242',
    name: 'Gemeindewerke Hördt',
  },
  {
    id: 'SNB919708421706',
    name: 'Gemeindewerke Hütschenhausen c/o SW Ramstein-Miesenbach GmbH',
  },
  {
    id: 'SNB962006136537',
    name: 'Gemeindewerke Kahl Versorgungsgesellschaft mbH',
  },
  {
    id: 'SNB981193584808',
    name: 'Gemeindewerke Kiefersfelden',
  },
  {
    id: 'SNB969688824103',
    name: 'Gemeindewerke Kirkel GmbH',
  },
  {
    id: 'SNB917087815666',
    name: 'Gemeindewerke Krauchenwies - Stromversorgung -',
  },
  {
    id: 'SNB958561375085',
    name: 'Gemeindewerke Markt Lichtenau',
  },
  {
    id: 'SNB972265030262',
    name: 'Gemeindewerke Münchweiler a.d.Rodalb Anstalt des öffentlichen Rechts',
  },
  {
    id: 'SNB984571613121',
    name: 'Gemeindewerke Neuendettelsau',
  },
  {
    id: 'SNB981336194529',
    name: 'Gemeindewerke Nüdlingen',
  },
  {
    id: 'SNB987153361809',
    name: 'Gemeindewerke Nümbrecht GmbH',
  },
  {
    id: 'SNB950777700255',
    name: 'Gemeindewerke Oberaudorf',
  },
  {
    id: 'SNB955872978110',
    name: 'Gemeindewerke Partenstein',
  },
  {
    id: 'SNB985871274975',
    name: 'Kommunalunternehmen Gemeindewerke Peißenberg ',
  },
  {
    id: 'SNB915728555230',
    name: 'Gemeindewerke Pleinfeld',
  },
  {
    id: 'SNB962756415364',
    name: 'Gemeindewerke Rückersdorf',
  },
  {
    id: 'SNB951261935979',
    name: 'Gemeindewerke Rülzheim',
  },
  {
    id: 'SNB981972152532',
    name: 'Gemeindewerke Schönkirchen GmbH',
  },
  {
    id: 'SNB959475630567',
    name: 'Gemeindewerke Schutterwald (GWS)',
  },
  {
    id: 'SNB944419421783',
    name: 'Gemeindewerke Schwarzenbruck GmbH (GWS)',
  },
  {
    id: 'SNB915686229082',
    name: 'Gemeindewerke Sinzheim',
  },
  {
    id: 'SNB947553215997',
    name: 'Kommunalunternehmen Gemeindewerke Stammbach Anstalt des öffentlichen Rechts des Marktes Stammbach',
  },
  {
    id: 'SNB916657570554',
    name: 'Gemeindewerke Steinhagen GmbH',
  },
  {
    id: 'SNB970879855325',
    name: 'Gemeindewerke Steißlingen',
  },
  {
    id: 'SNB983792571722',
    name: 'Gemeindewerke Wadgassen GmbH',
  },
  {
    id: 'SNB976297675927',
    name: 'Gemeindewerke Waging a. See',
  },
  {
    id: 'SNB962064980332',
    name: 'Gemeindewerke Waldfischbach-Burgalben',
  },
  {
    id: 'SNB966823215826',
    name: 'Gemeindewerke Weidenthal c/o Stadtwerke Kaiserslautern',
  },
  {
    id: 'SNB964137069203',
    name: 'Gemeindewerke Wendelstein KU',
  },
  {
    id: 'SNB978228078289',
    name: 'Gemeindewerke Wickede (Ruhr) GmbH',
  },
  {
    id: 'SNB945187645647',
    name: 'Gemeindewerke Wildeck',
  },
  {
    id: 'SNB946958756494',
    name: 'Gemeindewerke Wilhermsdorf',
  },
  {
    id: 'SNB925878615876',
    name: 'Gemeindliche Werke Hengersberg',
  },
  {
    id: 'SNB967068117678',
    name: 'gemeinsames Kommunalunternehmen oberes Egertal',
  },
  {
    id: 'SNB948816192529',
    name: 'GeraNetz GmbH',
  },
  {
    id: 'SNB946224752939',
    name: 'GETEC net alpha GmbH & Co. KG',
  },
  {
    id: 'SNB910938226123',
    name: 'GETEC net beta GmbH & Co. KG',
  },
  {
    id: 'SNB953793591142',
    name: 'GETEC net delta GmbH & Co. KG',
  },
  {
    id: 'SNB990342496558',
    name: 'GETEC net epsilon GmbH & Co. KG',
  },
  {
    id: 'SNB946891490059',
    name: 'GETEC net eta GmbH & Co. KG',
  },
  {
    id: 'SNB920821787464',
    name: 'GETEC net gamma GmbH & Co. KG',
  },
  {
    id: 'SNB914386072127',
    name: 'GETEC net theta GmbH & Co. KG',
  },
  {
    id: 'SNB919917233459',
    name: 'GETEC net zeta GmbH & Co. KG',
  },
  {
    id: 'SNB933529129573',
    name: 'Getreidemühle Zwiefalten eG',
  },
  {
    id: 'SNB920157746937',
    name: 'GEW Wilhelmshaven GmbH',
  },
  {
    id: 'SNB919208961290',
    name: 'Gewerbepark Nürnberg-Feucht Versorgungs- u. Abwasserentsorgungsgesellschaft mit beschränkter Haftung',
  },
  {
    id: 'SNB968670865650',
    name: 'GGEW, Gruppen-Gas- und Elektrizitätswerk Bergstraße AG',
  },
  {
    id: 'SNB930067626847',
    name: 'Greizer Energienetze GmbH',
  },
  {
    id: 'SNB935600499711',
    name: 'GSW Gemeinschaftsstadtwerke GmbH Kamen, Bönen, Bergkamen',
  },
  {
    id: 'SNB981984960101',
    name: 'GWS Stadtwerke Hameln GmbH',
  },
  {
    id: 'SNB977374861035',
    name: 'Halberstadtwerke GmbH',
  },
  {
    id: 'SNB985729975610',
    name: 'Hanau Netz GmbH',
  },
  {
    id: 'SNB984607096621',
    name: 'Harz Energie Netz GmbH',
  },
  {
    id: 'SNB934355412402',
    name: 'Havelstrom Zehdenick GmbH',
  },
  {
    id: 'SNB924453035597',
    name: 'Hellenstein-Energie-Logistik GmbH',
  },
  {
    id: 'SNB970179850242',
    name: 'Hermann Geuder e.K.',
  },
  {
    id: 'SNB964592501355',
    name: 'Hertener Stadtwerke GmbH',
  },
  {
    id: 'SNB930312838582',
    name: 'Herzo Werke GmbH',
  },
  {
    id: 'SNB977206503256',
    name: 'HEW HofEnergie+Wasser GmbH',
  },
  {
    id: 'SNB982085566391',
    name: 'HEWA GmbH',
  },
  {
    id: 'SNB910824052225',
    name: 'HKW Blumenthal GmbH',
  },
  {
    id: 'SNB974319144116',
    name: 'IGS Netze GmbH',
  },
  {
    id: 'SNB916663914472',
    name: 'inetz GmbH',
  },
  {
    id: 'SNB911960309587',
    name: 'infra fürth gmbh',
  },
  {
    id: 'SNB982722829230',
    name: 'InfraLeuna GmbH',
  },
  {
    id: 'SNB942732578894',
    name: 'InfraServ Gendorf Netze GmbH',
  },
  {
    id: 'SNB948485211972',
    name: 'YNCORIS GmbH & Co. KG',
  },
  {
    id: 'SNB960884494671',
    name: 'InfraServ GmbH & Co. Wiesbaden KG',
  },
  {
    id: 'SNB971962135690',
    name: 'Infrastrukturbetrieb der Stadt Arneburg',
  },
  {
    id: 'SNB911641710114',
    name: 'Regionetz GmbH',
  },
  {
    id: 'SNB955784827612',
    name: 'Karlsruher Institut für Technologie',
  },
  {
    id: 'SNB964573708865',
    name: 'KEW Karwendel Energie und Wasser GmbH ',
  },
  {
    id: 'SNB913273314623',
    name: 'KBG Kraftstrom- Bezugsgenossenschaft Homberg eG',
  },
  {
    id: 'SNB951760950909',
    name: 'Keep - Kommunale Eisenberger Energiepartner GmbH',
  },
  {
    id: 'SNB943841101959',
    name: 'KEW Kommunale Energie- und Wasserversorgung AG',
  },
  {
    id: 'SNB986580518855',
    name: 'KommEnergie GmbH',
  },
  {
    id: 'SNB972153058149',
    name: 'Kommunale Energienetze Inn-Salzach GmbH & Co. KG',
  },
  {
    id: 'SNB912218404412',
    name: 'Kommunale Energieversorgung GmbH Eisenhüttenstadt',
  },
  {
    id: 'SNB935578300972',
    name: 'TWL Netze GmbH',
  },
  {
    id: 'SNB990329664031',
    name: 'Kommunalunternehmen Stadtwerke Klingenberg a.M. (AöR)',
  },
  {
    id: 'SNB987171059405',
    name: 'Kraftwerk Farchant A. Poettinger & Co. KG',
  },
  {
    id: 'SNB957361726592',
    name: 'Kraftwerk Köhlgartenwiese GmbH',
  },
  {
    id: 'SNB937858140285',
    name: 'Kreiswerke Main-Kinzig GmbH',
  },
  {
    id: 'SNB922161652860',
    name: 'KWH Netz GmbH',
  },
  {
    id: 'SNB920357766414',
    name: 'Leitungspartner GmbH',
  },
  {
    id: 'SNB911705062982',
    name: 'LEW Verteilnetz GmbH',
  },
  {
    id: 'SNB922269370765',
    name: 'Licht- und Kraftwerke Helmbrechts GmbH',
  },
  {
    id: 'SNB919657321775',
    name: 'Licht- und Kraftwerke Sonneberg GmbH',
  },
  {
    id: 'SNB943319305469',
    name: 'Licht-, Kraft- und Wasserwerke Kitzingen GmbH',
  },
  {
    id: 'SNB957862279702',
    name: 'LSW Netz GmbH & Co. KG',
  },
  {
    id: 'SNB915316807789',
    name: 'Mainfranken Netze GmbH',
  },
  {
    id: 'SNB983526428810',
    name: 'Mainnetz GmbH',
  },
  {
    id: 'SNB974647435931',
    name: 'Mainsite GmbH & Co. KG',
  },
  {
    id: 'SNB943571241628',
    name: 'Maintal-Werke-GmbH-Stadtwerke der Stadt Maintal',
  },
  {
    id: 'SNB997826747014',
    name: 'Markt Egloffstein',
  },
  {
    id: 'SNB932489723517',
    name: 'Markt Obernzell Elektrizitäts- versorgungsunternehmen',
  },
  {
    id: 'SNB931774737192',
    name: 'Markt Stockstadt - Gemeindewerke -',
  },
  {
    id: 'SNB923242117018',
    name: 'Markt Thüngen - Stromversorgung',
  },
  {
    id: 'SNB946115797155',
    name: 'Markt Zellingen -Versorgungsbetriebe-',
  },
  {
    id: 'SNB973875583315',
    name: 'N-ERGIE Netz GmbH',
  },
  {
    id: 'SNB914731268120',
    name: 'MEGA Monheimer Elektrizitäts- und Gasversorgung GmbH',
  },
  {
    id: 'SNB914103081760',
    name: 'Meißener Stadtwerke GmbH',
  },
  {
    id: 'SNB916269213931',
    name: 'Mitteldeutsche Netzgesellschaft Strom mbH',
  },
  {
    id: 'SNB970253419624',
    name: 'Müller - Mühle GmbH & Co. KG ',
  },
  {
    id: 'SNB980883363112',
    name: 'münsterNETZ GmbH',
  },
  {
    id: 'SNB943170046990',
    name: 'MVE eurokom Gesellschaft für Energie- und Kommunikationsleistungen mbH',
  },
  {
    id: 'SNB985472799266',
    name: 'MVV Netze GmbH',
  },
  {
    id: 'SNB982034089728',
    name: 'Netz & Energie Betriebsgesellschaft mbH',
  },
  {
    id: 'SNB948859455841',
    name: 'Netz Leipzig GmbH',
  },
  {
    id: 'SNB983425156814',
    name: 'Netz Lübeck GmbH',
  },
  {
    id: 'SNB915030239484',
    name: 'Netzbetrieb Hirschberg GmbH & Co. KG',
  },
  {
    id: 'SNB939517994215',
    name: 'NETZE Bad Langensalza GmbH',
  },
  {
    id: 'SNB948311994307',
    name: 'Netze BW GmbH',
  },
  {
    id: 'SNB916123648602',
    name: 'Netze Duisburg GmbH',
  },
  {
    id: 'SNB933459598975',
    name: 'Netze Magdeburg GmbH',
  },
  {
    id: 'SNB913992545742',
    name: 'Überlandwerk Mittelbaden GmbH & Co. KG',
  },
  {
    id: 'SNB933767388565',
    name: 'Netzgesellschaft Ahlen mbH',
  },
  {
    id: 'SNB978051166283',
    name: 'Netzgesellschaft Bitterfeld-Wolfen mbH',
  },
  {
    id: 'SNB933956506145',
    name: 'Netzgesellschaft Düsseldorf mbH',
  },
  {
    id: 'SNB917432806905',
    name: 'Netzgesellschaft Eisenberg mbH',
  },
  {
    id: 'SNB922055731633',
    name: 'Netzgesellschaft Forst (Lausitz) mbH & Co. KG',
  },
  {
    id: 'SNB954814647626',
    name: 'Netzgesellschaft Frankfurt (Oder) mbH',
  },
  {
    id: 'SNB931546188436',
    name: 'Netzgesellschaft Gütersloh mbH',
  },
  {
    id: 'SNB934185023519',
    name: 'Netzgesellschaft Lübbecke mbH',
  },
  {
    id: 'SNB935556509052',
    name: 'Netzgesellschaft Ostwürttemberg DonauRies GmbH',
  },
  {
    id: 'SNB929027950139',
    name: 'Netzgesellschaft Potsdam GmbH',
  },
  {
    id: 'SNB913130054136',
    name: 'Netzgesellschaft Schwerin mbH (NGS)',
  },
  {
    id: 'SNB929088252340',
    name: 'Netzwerke Merzig GmbH',
  },
  {
    id: 'SNB915471253889',
    name: 'Netzwerke Saarlouis GmbH',
  },
  {
    id: 'SNB969164438589',
    name: 'Netzwerke Wadern GmbH',
  },
  {
    id: 'SNB939624707241',
    name: 'Neubrandenburger Stadtwerke GmbH',
  },
  {
    id: 'SNB940437318166',
    name: 'NEW Netz GmbH',
  },
  {
    id: 'SNB911144461377',
    name: 'NGN Netzgesellschaft Niederrhein mbH',
  },
  {
    id: 'SNB998819299022',
    name: 'NHF Netzgesellschaft Heilbronn-Franken mbH',
  },
  {
    id: 'SNB917783023525',
    name: 'Niedersachsen Ports GmbH & Co. KG',
  },
  {
    id: 'SNB959176447266',
    name: 'Nordhausen Netz GmbH',
  },
  {
    id: 'SNB921899277833',
    name: 'NRM Netzdienste Rhein-Main GmbH',
  },
  {
    id: 'SNB945532057606',
    name: 'nvb Nordhorner Versorgungsbetriebe GmbH',
  },
  {
    id: 'SNB978975711255',
    name: 'NWS Netzwerke Saarwellingen GmbH',
  },
  {
    id: 'SNB992672107807',
    name: 'Oberhausener Netzgesellschaft mbH',
  },
  {
    id: 'SNB949124413085',
    name: 'Obermaier und Gerg Grundstücksverwaltung KG',
  },
  {
    id: 'SNB961246227906',
    name: 'Odenwald Netzgesellschaft GmbH & Co. KG',
  },
  {
    id: 'SNB959255155907',
    name: 'Osterholzer Stadtwerke GmbH & Co. KG',
  },
  {
    id: 'SNB934071779865',
    name: 'OsthessenNetz GmbH',
  },
  {
    id: 'SNB958487084566',
    name: 'Outokumpu Nirosta GmbH',
  },
  {
    id: 'SNB969534177940',
    name: 'ovag Netz GmbH',
  },
  {
    id: 'SNB985069443664',
    name: 'OXEA Services GmbH',
  },
  {
    id: 'SNB961471621746',
    name: 'Pfalzwerke Netz AG',
  },
  {
    id: 'SNB971573473594',
    name: 'Pharmaserv GmbH',
  },
  {
    id: 'SNB983497881744',
    name: 'Philipp Maier jun. Berneck, Inhaber Wilhelm Kempf Erben',
  },
  {
    id: 'SNB988532040636',
    name: 'PVU Energienetze GmbH',
  },
  {
    id: 'SNB966494112844',
    name: 'Raiffeisenbank Greding-Thalmässing eG',
  },
  {
    id: 'SNB963995572245',
    name: 'REDINET Burgenland GmbH',
  },
  {
    id: 'SNB941929592729',
    name: 'Regensburg Netz GmbH',
  },
  {
    id: 'SNB942274543879',
    name: 'Regionalnetze Linzgau GmbH',
  },
  {
    id: 'SNB974239978785',
    name: 'Regionalwerk Bodensee Netze GmbH & Co. KG',
  },
  {
    id: 'SNB979950878543',
    name: 'Remstalwerk Netzgesellschaft GmbH',
  },
  {
    id: 'SNB912239808732',
    name: 'Rheinhessische Energie- und Wasserversorgungs-GmbH',
  },
  {
    id: 'SNB924477581384',
    name: 'Rheinische NETZGesellschaft mbH',
  },
  {
    id: 'SNB976863966633',
    name: 'Rothmoser GmbH & Co. KG',
  },
  {
    id: 'SNB958237843443',
    name: 'Saalfelder Energienetze GmbH',
  },
  {
    id: 'SNB953868012787',
    name: 'Schleswiger Stadtwerke GmbH',
  },
  {
    id: 'SNB919861978666',
    name: 'Schleswig-Holstein Netz AG',
  },
  {
    id: 'SNB950960779068',
    name: 'SEW Stromversorgungs GmbH',
  },
  {
    id: 'SNB994887596117',
    name: 'Solvay Chemicals GmbH',
  },
  {
    id: 'SNB932006596143',
    name: 'Sömmerdaer Energieversorgung GmbH',
  },
  {
    id: 'SNB989025785690',
    name: 'SSW Netz GmbH',
  },
  {
    id: 'SNB931823254809',
    name: 'Stadt Burgbernheim - Stadtwerke',
  },
  {
    id: 'SNB958680286002',
    name: 'Stadtwerke Hollfeld',
  },
  {
    id: 'SNB935738221819',
    name: 'Stadt Langenzenn - Stadtwerke -',
  },
  {
    id: 'SNB922689183730',
    name: 'Stadt- und Überlandwerke GmbH Luckau-Lübbenau',
  },
  {
    id: 'SNB943531720705',
    name: 'Städtische Betriebswerke Luckenwalde GmbH',
  },
  {
    id: 'SNB946013720880',
    name: 'Städtische Werke Borna Netz GmbH',
  },
  {
    id: 'SNB935482852901',
    name: 'Städtische Werke Netz+Service GmbH',
  },
  {
    id: 'SNB926394976090',
    name: 'Städtische Werke Spremberg (Lausitz) GmbH',
  },
  {
    id: 'SNB956377097702',
    name: 'Städtisches Kommunalunternehmen Baiersdorf AdöR',
  },
  {
    id: 'SNB913346629968',
    name: 'Stadtwerke Barmstedt',
  },
  {
    id: 'SNB961666410285',
    name: 'Stadtnetze Neustadt a. Rbge. GmbH & Co. KG',
  },
  {
    id: 'SNB993059842564',
    name: 'Stadtwerk am See GmbH & Co. KG',
  },
  {
    id: 'SNB964046129302',
    name: 'Stadtwerk Haßfurt GmbH',
  },
  {
    id: 'SNB936176430474',
    name: 'Stadtwerk Tauberfranken GmbH',
  },
  {
    id: 'SNB957404386462',
    name: 'Stadtwerke - Altm. Gas-, Wasseru.Elektrizitätswerke GmbH Stendal',
  },
  {
    id: 'SNB982726407335',
    name: 'Stadtwerke Aalen GmbH',
  },
  {
    id: 'SNB942257679137',
    name: 'Stadtwerke Achim AG',
  },
  {
    id: 'SNB977443469322',
    name: 'Stadtwerke Ahaus GmbH',
  },
  {
    id: 'SNB947092763157',
    name: 'Stadtwerke Altdorf GmbH',
  },
  {
    id: 'SNB947709605108',
    name: 'Stadtwerke Altensteig',
  },
  {
    id: 'SNB978191145308',
    name: 'Stadtwerke Amberg Versorgungs GmbH',
  },
  {
    id: 'SNB981335690930',
    name: 'Stadtwerke Andernach Energie GmbH',
  },
  {
    id: 'SNB936769439815',
    name: 'Stadtwerke Annaberg-Buchholz Energie AG',
  },
  {
    id: 'SNB972040623122',
    name: 'Stadtwerke Annweiler am Trifels',
  },
  {
    id: 'SNB937406641264',
    name: 'Stadtwerke Ansbach GmbH',
  },
  {
    id: 'SNB985993443181',
    name: 'Stadtwerke Arnstadt Netz GmbH & Co. KG',
  },
  {
    id: 'SNB957591716776',
    name: 'Stadtwerke Aue - Bad Schlema GmbH',
  },
  {
    id: 'SNB939779591900',
    name: 'Stadtwerke Bad Aibling',
  },
  {
    id: 'SNB921299925846',
    name: 'Stadtwerke Bad Bergzabern GmbH',
  },
  {
    id: 'SNB960502792271',
    name: 'Stadtwerke Bad Bramstedt Netz GmbH',
  },
  {
    id: 'SNB983359308570',
    name: 'Stadtwerke Bad Brückenau GmbH',
  },
  {
    id: 'SNB918290153354',
    name: 'Stadtwerke Bad Dürkheim GmbH',
  },
  {
    id: 'SNB924330086940',
    name: 'Stadtwerke Bad Harzburg GmbH',
  },
  {
    id: 'SNB953975499051',
    name: 'Stadtwerke Bad Herrenalb GmbH',
  },
  {
    id: 'SNB968949417344',
    name: 'Stadtwerke Bad Hersfeld GmbH',
  },
  {
    id: 'SNB911031559460',
    name: 'Stadtwerke Bad Kissingen GmbH',
  },
  {
    id: 'SNB941424038838',
    name: 'Stadtwerke Bad Nauheim GmbH',
  },
  {
    id: 'SNB977253144464',
    name: 'Stadtwerke Bad Neustadt a. d. Saale',
  },
  {
    id: 'SNB984060961757',
    name: 'Stadtwerke Bad Pyrmont GmbH',
  },
  {
    id: 'SNB958672501014',
    name: 'Stadtwerke Bad Reichenhall KU',
  },
  {
    id: 'SNB967186419241',
    name: 'Stadtwerke Bad Rodach',
  },
  {
    id: 'SNB967958627669',
    name: 'Stadtwerke Bad Sachsa Gesellschaft mit beschränkter Haftung',
  },
  {
    id: 'SNB934457029447',
    name: 'Stadtwerke Bad Säckingen GmbH',
  },
  {
    id: 'SNB948413721931',
    name: 'Stadtwerke Bad Salzuflen GmbH',
  },
  {
    id: 'SNB943203125821',
    name: 'Stadtwerke Bad Saulgau',
  },
  {
    id: 'SNB949422762892',
    name: 'Stadtwerke Bad Sooden-Allendorf',
  },
  {
    id: 'SNB982671807549',
    name: 'Stadtwerke Bad Tölz GmbH',
  },
  {
    id: 'SNB959373877170',
    name: 'Stadtwerke Bad Vilbel GmbH',
  },
  {
    id: 'SNB946710442153',
    name: 'Stadtwerke Bad Wildbad GmbH & Co. KG',
  },
  {
    id: 'SNB963795614626',
    name: 'Stadtwerke Bad Windsheim',
  },
  {
    id: 'SNB948741734467',
    name: 'Stadtwerke Bad Wörishofen',
  },
  {
    id: 'SNB931622346583',
    name: 'Stadtwerke Baden-Baden',
  },
  {
    id: 'SNB963746327452',
    name: 'Stadtwerke Balingen',
  },
  {
    id: 'SNB949646353012',
    name: 'Stadtwerke Bamberg Energie- und Wasserversorgungs GmbH',
  },
  {
    id: 'SNB967782555602',
    name: 'Stadtwerke Bayreuth Energie und Wasser GmbH',
  },
  {
    id: 'SNB959513498364',
    name: 'Stadtwerke Bebra GmbH',
  },
  {
    id: 'SNB962890977544',
    name: 'Stadtwerke Bernau GmbH',
  },
  {
    id: 'SNB953669866350',
    name: 'Stadtwerke Bernburg GmbH',
  },
  {
    id: 'SNB955586052717',
    name: 'Stadtwerke Bexbach GmbH',
  },
  {
    id: 'SNB910950265032',
    name: 'Stadtwerke Bietigheim-Bissingen GmbH',
  },
  {
    id: 'SNB919654931526',
    name: 'Stadtwerke Blankenburg GmbH',
  },
  {
    id: 'SNB922514070884',
    name: 'Stadtwerke Bliestal GmbH',
  },
  {
    id: 'SNB922607376381',
    name: 'Stadtwerke Bochum Netz GmbH',
  },
  {
    id: 'SNB982380015723',
    name: 'Stadtwerke Bogen GmbH',
  },
  {
    id: 'SNB930423383254',
    name: 'Stadtwerke Böhmetal GmbH',
  },
  {
    id: 'SNB982432856366',
    name: 'Stadtwerke Borken/Westf. GmbH',
  },
  {
    id: 'SNB955266506998',
    name: 'Stadtwerke Bramsche GmbH',
  },
  {
    id: 'SNB913244202027',
    name: 'Stadtwerke Bretten GmbH',
  },
  {
    id: 'SNB983444187332',
    name: 'Stadtwerke Brühl GmbH',
  },
  {
    id: 'SNB951835062254',
    name: 'Stadtwerke Brunsbüttel GmbH',
  },
  {
    id: 'SNB922393870476',
    name: 'Stadtwerke Buchen GmbH & Co KG',
  },
  {
    id: 'SNB968489334224',
    name: 'Stadtwerke Buchholz in der Nordheide GmbH',
  },
  {
    id: 'SNB914946450877',
    name: 'Stadtwerke Bühl GmbH',
  },
  {
    id: 'SNB927160517950',
    name: 'Stadtwerke Burg Energienetze GmbH',
  },
  {
    id: 'SNB949369515353',
    name: 'Stadtwerke Burgdorf Netz GmbH',
  },
  {
    id: 'SNB974547197724',
    name: 'Stadtwerke Buxtehude GmbH',
  },
  {
    id: 'SNB990522725676',
    name: 'Stadtwerke Cham GmbH',
  },
  {
    id: 'SNB952939058372',
    name: 'Stadtwerke Clausthal-Zellerfeld GmbH',
  },
  {
    id: 'SNB943480673763',
    name: 'Stadtwerke Coesfeld GmbH',
  },
  {
    id: 'SNB934532229953',
    name: 'Stadtwerke Crailsheim GmbH',
  },
  {
    id: 'SNB945149216045',
    name: 'Stadtwerke Dachau Eigenbetr. d. Stadt Dachau',
  },
  {
    id: 'SNB924793953759',
    name: 'Stadtwerke Deggendorf GmbH',
  },
  {
    id: 'SNB984269982003',
    name: 'Stadtwerke Deidesheim GmbH',
  },
  {
    id: 'SNB937001443546',
    name: 'Stadtwerke Delitzsch GmbH',
  },
  {
    id: 'SNB924774487556',
    name: 'Stadtwerke Detmold GmbH',
  },
  {
    id: 'SNB977581070640',
    name: 'Stadtwerke Dettelbach',
  },
  {
    id: 'SNB991561247815',
    name: 'Stadtwerke Dillingen/Saar Netzgesellschaft mbH',
  },
  {
    id: 'SNB944601935326',
    name: 'Stadtwerke Dingolfing GmbH',
  },
  {
    id: 'SNB990562890006',
    name: 'Stadtwerke Dinkelsbühl',
  },
  {
    id: 'SNB976679550309',
    name: 'Stadtwerke Döbeln GmbH',
  },
  {
    id: 'SNB925050442719',
    name: 'Stadtwerke Dorfen GmbH',
  },
  {
    id: 'SNB947698671429',
    name: 'Stadtwerke Dreieich GmbH',
  },
  {
    id: 'SNB926697076725',
    name: 'Stadtwerke Dülmen GmbH',
  },
  {
    id: 'SNB943604361118',
    name: 'Stadtwerke Eberbach',
  },
  {
    id: 'SNB914522191989',
    name: 'Stadtwerke Ebermannstadt Versorgungsbetriebe GmbH',
  },
  {
    id: 'SNB968646876970',
    name: 'Stadtwerke Eckernförde GmbH',
  },
  {
    id: 'SNB971076036227',
    name: 'Stadtwerke Eichstätt Versorgungs-GmbH',
  },
  {
    id: 'SNB977174706994',
    name: 'Stadtwerke Eilenburg GmbH',
  },
  {
    id: 'SNB965692805121',
    name: 'Stadtwerke Einbeck GmbH',
  },
  {
    id: 'SNB920699937404',
    name: 'Stadtwerke Elbtal GmbH',
  },
  {
    id: 'SNB916743652645',
    name: 'Stadtwerke Elmshorn',
  },
  {
    id: 'SNB941183960449',
    name: 'Stadtwerke Emden GmbH',
  },
  {
    id: 'SNB948068461008',
    name: 'Stadtwerke Emmendingen GmbH',
  },
  {
    id: 'SNB986190606218',
    name: 'Stadtwerke Emmerich GmbH',
  },
  {
    id: 'SNB958416423039',
    name: 'Stadtwerke Emsdetten GmbH',
  },
  {
    id: 'SNB945861817537',
    name: 'Stadtwerke Jena Netze GmbH',
  },
  {
    id: 'SNB959959730332',
    name: 'Stadtwerke Engen GmbH',
  },
  {
    id: 'SNB918156808725',
    name: 'Stadtwerke Erkrath GmbH',
  },
  {
    id: 'SNB940847187345',
    name: 'Stadtwerke Eschwege GmbH',
  },
  {
    id: 'SNB932375556731',
    name: 'Stadtwerke Ostmünsterland GmbH & Co. KG',
  },
  {
    id: 'SNB937094451244',
    name: 'Stadtwerke Eutin GmbH',
  },
  {
    id: 'SNB922030852827',
    name: 'Stadtwerke EVB Huntetal GmbH',
  },
  {
    id: 'SNB964273276183',
    name: 'Stadtwerke Fellbach GmbH',
  },
  {
    id: 'SNB921471558077',
    name: 'Stadtwerke Feuchtwangen',
  },
  {
    id: 'SNB957549782006',
    name: 'Stadtwerke Finsterwalde GmbH',
  },
  {
    id: 'SNB922220582657',
    name: 'Stadtwerke Flensburg GmbH',
  },
  {
    id: 'SNB996457394093',
    name: 'Stadtwerke Forchheim GmbH',
  },
  {
    id: 'SNB961745390019',
    name: 'Stadtwerke Frankenthal GmbH',
  },
  {
    id: 'SNB973733148182',
    name: 'Stadtwerke Freudenstadt GmbH & Co. KG',
  },
  {
    id: 'SNB912063565672',
    name: 'Stadtwerke Fröndenberg GmbH',
  },
  {
    id: 'SNB985701689504',
    name: 'Stadtwerke Fürstenfeldbruck GmbH',
  },
  {
    id: 'SNB914668240749',
    name: 'Stadtwerke Furth im Wald GmbH & Co. KG',
  },
  {
    id: 'SNB925565312521',
    name: 'Stadtwerke Gaggenau',
  },
  {
    id: 'SNB960882503184',
    name: 'Stadtwerke Geesthacht GmbH',
  },
  {
    id: 'SNB965107360993',
    name: 'Stadtwerke Geldern Netz GmbH',
  },
  {
    id: 'SNB922793626642',
    name: 'Stadtwerke Gengenbach- Versorgungsbetriebe',
  },
  {
    id: 'SNB977481237679',
    name: 'Stadtwerke Georgsmarienhütte Netz GmbH',
  },
  {
    id: 'SNB982049301273',
    name: 'Stadtwerke Germersheim GmbH',
  },
  {
    id: 'SNB963070917732',
    name: 'Stadtwerke Glauchau Dienstleistungsgesellschaft mbH',
  },
  {
    id: 'SNB980181102130',
    name: 'Stadtwerke Glückstadt GmbH',
  },
  {
    id: 'SNB985431470335',
    name: 'Stadtwerke GmbH Bad Kreuznach',
  },
  {
    id: 'SNB941004899811',
    name: 'Stadtwerke Goch GmbH',
  },
  {
    id: 'SNB938672757734',
    name: 'Stadtwerke Görlitz AG',
  },
  {
    id: 'SNB961316124487',
    name: 'Stadtwerke Gotha Netz GmbH',
  },
  {
    id: 'SNB998044089535',
    name: 'STADTWERKE GREVEN GMBH',
  },
  {
    id: 'SNB991689251534',
    name: 'Stadtwerke Grevesmühlen GmbH',
  },
  {
    id: 'SNB934949020686',
    name: 'Stadtwerke Gronau GmbH',
  },
  {
    id: 'SNB966809778161',
    name: 'Stadtwerke Groß-Gerau Versorgungs GmbH',
  },
  {
    id: 'SNB958070514050',
    name: 'Stadtwerke Grünstadt GmbH',
  },
  {
    id: 'SNB953794435957',
    name: 'Stadtwerke Gunzenhausen GmbH',
  },
  {
    id: 'SNB983029590205',
    name: 'Stadtwerke Güstrow GmbH',
  },
  {
    id: 'SNB928602915495',
    name: 'Stadtwerke Hagenow GmbH',
  },
  {
    id: 'SNB945552907998',
    name: 'Stadtwerke Haiger',
  },
  {
    id: 'SNB959120377328',
    name: 'Stadtwerke Haldensleben GmbH',
  },
  {
    id: 'SNB921816651920',
    name: 'Stadtwerke Haltern am See GmbH',
  },
  {
    id: 'SNB916711029424',
    name: 'Stadtwerke Hammelburg GmbH',
  },
  {
    id: 'SNB972046955654',
    name: 'Stadtwerke Harsewinkel GmbH',
  },
  {
    id: 'SNB989253327099',
    name: 'Stadtwerke Haslach i.K.',
  },
  {
    id: 'SNB960729432592',
    name: 'Stadtwerke Havelberg GmbH',
  },
  {
    id: 'SNB953938790515',
    name: 'Stadtwerke Heide GmbH',
  },
  {
    id: 'SNB938476571321',
    name: 'Stadtwerke Heidelberg Netze GmbH',
  },
  {
    id: 'SNB968694358282',
    name: 'Stadtwerke Heiligenhaus GmbH',
  },
  {
    id: 'SNB980412578185',
    name: 'Stadtwerke Heilsbronn',
  },
  {
    id: 'SNB939428749966',
    name: 'Stadtwerke Hemau',
  },
  {
    id: 'SNB939653726848',
    name: 'Stadtwerke Herborn GmbH',
  },
  {
    id: 'SNB963671951227',
    name: 'Stadtwerke Herne AG',
  },
  {
    id: 'SNB944962954653',
    name: 'Stadtwerke Hettstedt GmbH',
  },
  {
    id: 'SNB969826201797',
    name: 'Stadtwerke Hilden GmbH',
  },
  {
    id: 'SNB967127819703',
    name: 'Stadtwerke Hockenheim',
  },
  {
    id: 'SNB954537392643',
    name: 'Stadtwerke Homburg GmbH',
  },
  {
    id: 'SNB964375043041',
    name: 'Stadtwerke Hünfeld GmbH',
  },
  {
    id: 'SNB950336540445',
    name: 'Stadtwerke Husum Netz GmbH',
  },
  {
    id: 'SNB964659661008',
    name: 'Stadtwerke Ilmenau GmbH',
  },
  {
    id: 'SNB911347846643',
    name: 'Stadtwerke Ingolstadt Netze GmbH',
  },
  {
    id: 'SNB913730249284',
    name: 'Stadtwerke Iserlohn GmbH',
  },
  {
    id: 'SNB946137378622',
    name: 'Stadtwerke Itzehoe GmbH',
  },
  {
    id: 'SNB973672371320',
    name: 'Stadtwerke Jülich GmbH',
  },
  {
    id: 'SNB933013692798',
    name: 'Stadtwerke Kaltenkirchen GmbH',
  },
  {
    id: 'SNB971087047229',
    name: 'Stadtwerke Karlsruhe Netzservice GmbH',
  },
  {
    id: 'SNB965500640463',
    name: 'STADTWERKE KELHEIM GmbH & Co KG',
  },
  {
    id: 'SNB943042904373',
    name: 'Stadtwerke Kempen GmbH',
  },
  {
    id: 'SNB935814055062',
    name: 'Stadtwerke Kleve GmbH',
  },
  {
    id: 'SNB971124937612',
    name: 'Stadtwerke Konstanz GmbH',
  },
  {
    id: 'SNB945021456095',
    name: 'Stadtwerke Kusel GmbH ',
  },
  {
    id: 'SNB959585826225',
    name: 'Stadtwerke Lambrecht (Pfalz) GmbH',
  },
  {
    id: 'SNB963499807249',
    name: 'Stadtwerke Landau a.d.Isar',
  },
  {
    id: 'SNB929663692172',
    name: 'Stadtwerke Landsberg KU',
  },
  {
    id: 'SNB928992067729',
    name: 'Stadtwerke Landshut',
  },
  {
    id: 'SNB965379905076',
    name: 'Stadtwerke Langen GmbH',
  },
  {
    id: 'SNB980345455409',
    name: 'Stadtwerke Lauterbach GmbH',
  },
  {
    id: 'SNB946090906887',
    name: 'Stadtwerke Leine-Solling GmbH',
  },
  {
    id: 'SNB967075358620',
    name: 'Stadtwerke Lemgo GmbH',
  },
  {
    id: 'SNB949152526504',
    name: 'Stadtwerke Lindau (B) GmbH & Co. KG',
  },
  {
    id: 'SNB982030394239',
    name: 'Stadtwerke Lingen GmbH',
  },
  {
    id: 'SNB916255659316',
    name: 'Stadtwerke Lippe-Weser Service GmbH & Co. KG',
  },
  {
    id: 'SNB985098042388',
    name: 'Stadtwerke Lippstadt GmbH',
  },
  {
    id: 'SNB926470799582',
    name: 'Stadtwerke Löbau GmbH',
  },
  {
    id: 'SNB915358347793',
    name: 'Stadtwerke Lübz GmbH',
  },
  {
    id: 'SNB978730380269',
    name: 'Stadtwerke Ludwigsburg - Kornwestheim GmbH',
  },
  {
    id: 'SNB983765888505',
    name: 'Stadtwerke Ludwigsfelde GmbH',
  },
  {
    id: 'SNB928200943784',
    name: 'Stadtwerke Ludwigslust-Grabow GmbH',
  },
  {
    id: 'SNB942111583372',
    name: 'Stadtwerke Lünen GmbH',
  },
  {
    id: 'SNB946425570127',
    name: 'Stadtwerke Lutherstadt Eisleben GmbH',
  },
  {
    id: 'SNB932107297727',
    name: 'Stadtwerke Lutherstadt Wittenberg GmbH',
  },
  {
    id: 'SNB959523885956',
    name: 'Mainzer Netze GmbH',
  },
  {
    id: 'SNB948470226516',
    name: 'Stadtwerke Malchow',
  },
  {
    id: 'SNB972740218178',
    name: 'Stadtwerke Marburg GmbH',
  },
  {
    id: 'SNB918070278383',
    name: 'Stadtwerke Meerane GmbH',
  },
  {
    id: 'SNB925883927308',
    name: 'Stadtwerke Meiningen GmbH',
  },
  {
    id: 'SNB922774216633',
    name: 'Stadtwerke Menden GmbH',
  },
  {
    id: 'SNB961816584323',
    name: 'Stadtwerke Mengen',
  },
  {
    id: 'SNB913006238462',
    name: 'Stadtwerke Merseburg GmbH',
  },
  {
    id: 'SNB961448362368',
    name: 'Stadtwerke Metzingen',
  },
  {
    id: 'SNB984863778941',
    name: 'Stadtwerke Mosbach GmbH',
  },
  {
    id: 'SNB947193557761',
    name: 'Stadtwerke Mössingen',
  },
  {
    id: 'SNB953132482766',
    name: 'Stadtwerke Mühlacker GmbH',
  },
  {
    id: 'SNB931986174853',
    name: 'Stadtwerke Mühlhausen Netz GmbH',
  },
  {
    id: 'SNB986042567117',
    name: 'Stadtwerke Mühlheim am Main GmbH',
  },
  {
    id: 'SNB956741146944',
    name: 'Stadtwerke Münchberg',
  },
  {
    id: 'SNB973056451075',
    name: 'Stadtwerke Munster-Bispingen GmbH',
  },
  {
    id: 'SNB985347645049',
    name: 'Stadtwerke Nettetal GmbH',
  },
  {
    id: 'SNB980054996408',
    name: 'Stadtwerke Neuburg a. d. Donau',
  },
  {
    id: 'SNB924181641435',
    name: 'Stadtwerke Neuffen AG',
  },
  {
    id: 'SNB960797798422',
    name: 'Stadtwerke Neu-Isenburg GmbH',
  },
  {
    id: 'SNB989365725226',
    name: 'Stadtwerke Neumarkt i. d. OPf. Energie GmbH',
  },
  {
    id: 'SNB955718588763',
    name: 'Stadtwerke Neunburg vorm Wald Strom GmbH',
  },
  {
    id: 'SNB920348005966',
    name: 'Stadtwerke Neuruppin GmbH',
  },
  {
    id: 'SNB988769717073',
    name: 'Stadtwerke Neustadt a. d. Donau',
  },
  {
    id: 'SNB965315499379',
    name: 'Stadtwerke Neustadt a.d. Aisch GmbH',
  },
  {
    id: 'SNB931294328658',
    name: 'Stadtwerke Neustadt an der Orla GmbH',
  },
  {
    id: 'SNB942305388936',
    name: 'Stadtwerke Neustadt an der Weinstraße GmbH',
  },
  {
    id: 'SNB933386930565',
    name: 'Stadtwerke Neustadt in Holstein',
  },
  {
    id: 'SNB914630088973',
    name: 'Stadtwerke Neustrelitz GmbH',
  },
  {
    id: 'SNB925999725461',
    name: 'Stadtwerke Neuwied GmbH',
  },
  {
    id: 'SNB951791941969',
    name: 'Stadtwerke Nordfriesland - Netz GmbH',
  },
  {
    id: 'SNB961943991735',
    name: 'Stadtwerke Niesky GmbH',
  },
  {
    id: 'SNB932374739180',
    name: 'Stadtwerke Norderney GmbH',
  },
  {
    id: 'SNB985965721965',
    name: 'Stadtwerke Norderstedt',
  },
  {
    id: 'SNB960060046328',
    name: 'SWN Stadtwerke Northeim GmbH',
  },
  {
    id: 'SNB965813404431',
    name: 'Stadtwerke Nortorf AöR',
  },
  {
    id: 'SNB948186469375',
    name: 'Stadtwerke Nürtingen GmbH',
  },
  {
    id: 'SNB963821222269',
    name: 'Stadtwerke Oberkirch GmbH',
  },
  {
    id: 'SNB934961797092',
    name: 'Stadtwerke Ochtrup',
  },
  {
    id: 'SNB941314694489',
    name: 'Stadtwerke Oelsnitz/V. GmbH',
  },
  {
    id: 'SNB967490557615',
    name: 'Stadtwerke Oerlinghausen GmbH',
  },
  {
    id: 'SNB991836941189',
    name: 'Stadtwerke Olbernhau GmbH',
  },
  {
    id: 'SNB975581504646',
    name: 'Stadtwerke Oldenburg in Holstein GmbH',
  },
  {
    id: 'SNB951105240061',
    name: 'Stadtwerke Oranienburg GmbH',
  },
  {
    id: 'SNB954662803168',
    name: 'Stadtwerke Pappenheim GmbH',
  },
  {
    id: 'SNB999125588145',
    name: 'Stadtwerke Parchim GmbH',
  },
  {
    id: 'SNB961833910969',
    name: 'Stadtwerke Pasewalk GmbH',
  },
  {
    id: 'SNB917625393281',
    name: 'Stadtwerke Passau GmbH',
  },
  {
    id: 'SNB954026274702',
    name: 'Stadtwerke Peine GmbH',
  },
  {
    id: 'SNB955607007702',
    name: 'Stadtwerke Pfarrkirchen',
  },
  {
    id: 'SNB927533168369',
    name: 'Stadtwerke Pinneberg GmbH',
  },
  {
    id: 'SNB955001358523',
    name: 'Stadtwerke Pirmasens Versorgungs GmbH',
  },
  {
    id: 'SNB917615238004',
    name: 'Stadtwerke Plattling',
  },
  {
    id: 'SNB941283828373',
    name: 'Stadtwerke Prenzlau GmbH',
  },
  {
    id: 'SNB922354559020',
    name: 'Stadtwerke Pritzwalk GmbH',
  },
  {
    id: 'SNB970223838288',
    name: 'Stadtwerke Quedlinburg GmbH',
  },
  {
    id: 'SNB948134408678',
    name: 'Stadtwerke Quickborn GmbH',
  },
  {
    id: 'SNB964262506406',
    name: 'Stadtwerke Radevormwald GmbH',
  },
  {
    id: 'SNB974041045040',
    name: 'Stadtwerke Radolfzell GmbH',
  },
  {
    id: 'SNB987569421388',
    name: 'Stadtwerke Ramstein-Miesenbach GmbH',
  },
  {
    id: 'SNB953661539375',
    name: 'Stadtwerke Ratingen GmbH',
  },
  {
    id: 'SNB959567240391',
    name: 'Stadtwerke Reichenbach/Vogtland GmbH',
  },
  {
    id: 'SNB926119738552',
    name: 'Stadtwerke Rendsburg GmbH',
  },
  {
    id: 'SNB979326623005',
    name: 'Stadtwerke Rhede GmbH',
  },
  {
    id: 'SNB951305396193',
    name: 'Stadtwerke Riesa GmbH',
  },
  {
    id: 'SNB924409922308',
    name: 'Stadtwerke Rinteln GmbH',
  },
  {
    id: 'SNB988838479086',
    name: 'Stadtwerke Rosenheim Netze GmbH',
  },
  {
    id: 'SNB939724292715',
    name: 'Stadtwerke Rostock Netzgesellschaft mbH',
  },
  {
    id: 'SNB976170444053',
    name: 'Stadtwerke Rotenburg (Wümme) GmbH',
  },
  {
    id: 'SNB927574397889',
    name: 'Stadtwerke Roth',
  },
  {
    id: 'SNB979202870318',
    name: 'Stadtwerke Rothenburg o.d.T. GmbH',
  },
  {
    id: 'SNB985382489820',
    name: 'Stadtwerke Saarbrücken Netz AG',
  },
  {
    id: 'SNB922861338965',
    name: 'Stadtwerke Sangerhausen GmbH',
  },
  {
    id: 'SNB924120395771',
    name: 'Stadtwerke Scheinfeld',
  },
  {
    id: 'SNB924685554682',
    name: 'Stadtwerke Schifferstadt',
  },
  {
    id: 'SNB942159258331',
    name: 'Stadtwerke Schkeuditz GmbH',
  },
  {
    id: 'SNB987617847795',
    name: 'Stadtwerke Schlitz',
  },
  {
    id: 'SNB979429791342',
    name: 'Stadtwerke Schneeberg GmbH',
  },
  {
    id: 'SNB950028563172',
    name: 'Stadtwerke Schneverdingen-Neuenkirchen GmbH',
  },
  {
    id: 'SNB935144085258',
    name: 'Stadtwerke Schorndorf GmbH',
  },
  {
    id: 'SNB944999584793',
    name: 'Stadtwerke Schramberg GmbH & Co. KG',
  },
  {
    id: 'SNB944294076061',
    name: 'Stadtwerke Schüttorf - Emsbüren GmbH',
  },
  {
    id: 'SNB962110557570',
    name: 'Stadtwerke Schwabach GmbH',
  },
  {
    id: 'SNB962618092306',
    name: 'Stadtwerke Schwäbisch Gmünd GmbH',
  },
  {
    id: 'SNB982660786343',
    name: 'Stadtwerke Schwäbisch Hall GmbH',
  },
  {
    id: 'SNB946717964085',
    name: 'Stadtwerke Schwarzenbach a.d. Saale',
  },
  {
    id: 'SNB985072256732',
    name: 'Stadtwerke Schwarzenberg GmbH',
  },
  {
    id: 'SNB913280322543',
    name: 'Stadtwerke Schwedt GmbH',
  },
  {
    id: 'SNB922811950100',
    name: 'Stadtwerke Schweinfurt GmbH',
  },
  {
    id: 'SNB960280760097',
    name: 'Stadtwerke Schwentinental GmbH',
  },
  {
    id: 'SNB932788203468',
    name: 'Stadtwerke Schwerte GmbH',
  },
  {
    id: 'SNB995034381532',
    name: 'Stadtwerke Senftenberg GmbH',
  },
  {
    id: 'SNB924431834525',
    name: 'Stadtwerke Sigmaringen',
  },
  {
    id: 'SNB953453232156',
    name: 'Stadtwerke Sindelfingen GmbH',
  },
  {
    id: 'SNB965118678667',
    name: 'Stadtwerke Soest GmbH',
  },
  {
    id: 'SNB947030954821',
    name: 'Stadtwerke Soltau GmbH & Co. KG',
  },
  {
    id: 'SNB987483520273',
    name: 'Stadtwerke Sondershausen Netz GmbH',
  },
  {
    id: 'SNB918097788087',
    name: 'Stadtwerke Speyer GmbH',
  },
  {
    id: 'SNB954187049256',
    name: 'Stadtwerke Springe GmbH',
  },
  {
    id: 'SNB926470603247',
    name: 'Stadtwerke St. Ingbert GmbH',
  },
  {
    id: 'SNB975659838086',
    name: 'Stadtwerke Stade GmbH',
  },
  {
    id: 'SNB976240506834',
    name: 'Stadtwerke Stadtroda GmbH',
  },
  {
    id: 'SNB910474681448',
    name: 'Stadtwerke Staßfurt GmbH',
  },
  {
    id: 'SNB943984165313',
    name: 'Stadtwerke Stein GmbH & Co. KG',
  },
  {
    id: 'SNB983384447602',
    name: 'Stadtwerke Stockach GmbH',
  },
  {
    id: 'SNB971641248901',
    name: 'Stadtwerke Straubing Strom und Gas GmbH',
  },
  {
    id: 'SNB975846871759',
    name: 'Stadtwerke Strausberg GmbH',
  },
  {
    id: 'SNB935760057516',
    name: 'Stadtwerke Suhl/Zella-Mehlis Netz GmbH',
  },
  {
    id: 'SNB943261073362',
    name: 'Stadtwerke Sulzbach/Saar GmbH',
  },
  {
    id: 'SNB932509765411',
    name: 'Stadtwerke Teterow GmbH',
  },
  {
    id: 'SNB938620426132',
    name: 'Stadtwerke Tirschenreuth',
  },
  {
    id: 'SNB933235634552',
    name: 'Stadtwerke Torgau GmbH',
  },
  {
    id: 'SNB914767582221',
    name: 'Stadtwerke Tornesch - Netz GmbH',
  },
  {
    id: 'SNB940718804685',
    name: 'Stadtwerke Traunstein GmbH & Co. KG',
  },
  {
    id: 'SNB976987786759',
    name: 'Stadtwerke Treuchtlingen',
  },
  {
    id: 'SNB966813503780',
    name: 'SWT Stadtwerke Trier Versorgungs-GmbH',
  },
  {
    id: 'SNB924659713978',
    name: 'Stadtwerke Troisdorf GmbH',
  },
  {
    id: 'SNB914963192408',
    name: 'Stadtwerke Trostberg Stromversorgung GmbH',
  },
  {
    id: 'SNB921695080347',
    name: 'Stadtwerke Tübingen GmbH',
  },
  {
    id: 'SNB922074927642',
    name: 'Stadtwerke Tuttlingen GmbH',
  },
  {
    id: 'SNB965557517831',
    name: 'Stadtwerke Uelzen GmbH',
  },
  {
    id: 'SNB947683785568',
    name: 'Stadtwerke Uffenheim',
  },
  {
    id: 'SNB934068635945',
    name: 'Stadtwerke Ulm/Neu-Ulm Netze GmbH',
  },
  {
    id: 'SNB944150243392',
    name: 'Stadtwerke Unna GmbH',
  },
  {
    id: 'SNB925861098273',
    name: 'Stadtwerke Uslar GmbH',
  },
  {
    id: 'SNB974492211483',
    name: 'Stadtwerke Velbert GmbH',
  },
  {
    id: 'SNB957440824454',
    name: 'Stadtwerke Velten GmbH',
  },
  {
    id: 'SNB962996832648',
    name: 'Stadtwerke Verden GmbH',
  },
  {
    id: 'SNB961283575572',
    name: 'Stadtwerke Viernheim Netz GmbH',
  },
  {
    id: 'SNB916927144072',
    name: 'Stadtwerke Villingen-Schwenningen GmbH',
  },
  {
    id: 'SNB932685335767',
    name: 'Stadtwerke Vilsbiburg',
  },
  {
    id: 'SNB967967636034',
    name: 'Stadtwerke Vilshofen GmbH',
  },
  {
    id: 'SNB945413736880',
    name: 'Stadtwerke Völklingen Netz GmbH',
  },
  {
    id: 'SNB968648650424',
    name: 'Stadtwerke Wachenheim',
  },
  {
    id: 'SNB969058795651',
    name: 'Stadtwerke Waiblingen GmbH',
  },
  {
    id: 'SNB920730809172',
    name: 'Stadtwerke Waldkirch GmbH',
  },
  {
    id: 'SNB985206131959',
    name: 'Stadtwerke Waldkirchen',
  },
  {
    id: 'SNB960416123321',
    name: 'Stadtwerke Waldkraiburg GmbH',
  },
  {
    id: 'SNB971196250442',
    name: 'Stadtwerke Waldmünchen',
  },
  {
    id: 'SNB933494191209',
    name: 'Stadtwerke Waldshut-Tiengen GmbH',
  },
  {
    id: 'SNB946790148600',
    name: 'Stadtwerke Walldorf GmbH & Co. KG',
  },
  {
    id: 'SNB969708579983',
    name: 'Stadtwerke Walldürn GmbH',
  },
  {
    id: 'SNB973505068113',
    name: 'Stadtwerke Waren GmbH',
  },
  {
    id: 'SNB929073868471',
    name: 'Stadtwerke Wasserburg a. Inn',
  },
  {
    id: 'SNB975283859389',
    name: 'Stadtwerke Wedel GmbH',
  },
  {
    id: 'SNB926480464456',
    name: 'Stadtwerke Weilburg GmbH',
  },
  {
    id: 'SNB935723521351',
    name: 'Stadtwerke Weinheim GmbH',
  },
  {
    id: 'SNB965819408044',
    name: 'STADTWERKE WEISSENBURG GmbH',
  },
  {
    id: 'SNB933274941888',
    name: 'Stadtwerke Weißenfels Energienetze GmbH',
  },
  {
    id: 'SNB918084816830',
    name: 'Stadtwerke Weißwasser GmbH',
  },
  {
    id: 'SNB962389410347',
    name: 'Stadtwerke Werdau GmbH',
  },
  {
    id: 'SNB979980141082',
    name: 'Stadtwerke Werl GmbH',
  },
  {
    id: 'SNB914879260819',
    name: 'Stadtwerke Wernigerode GmbH',
  },
  {
    id: 'SNB922051401837',
    name: 'Stadtwerke Wertheim GmbH',
  },
  {
    id: 'SNB950584553167',
    name: 'Stadtwerke Wiesbaden Netz GmbH',
  },
  {
    id: 'SNB919230329570',
    name: 'Stadtwerke Wilster',
  },
  {
    id: 'SNB957988771050',
    name: 'Stadtwerke Windsbach',
  },
  {
    id: 'SNB972723368326',
    name: 'Stadtwerke Winsen (Luhe) GmbH',
  },
  {
    id: 'SNB971007500575',
    name: 'Stadtwerke Witten GmbH',
  },
  {
    id: 'SNB941081544895',
    name: 'Stadtwerke Wittenberge GmbH',
  },
  {
    id: 'SNB937722627607',
    name: 'Stadtwerke Witzenhausen GmbH',
  },
  {
    id: 'SNB983546347757',
    name: 'Stadtwerke Wolfenbüttel GmbH',
  },
  {
    id: 'SNB917014884420',
    name: 'Stadtwerke Wolfhagen GmbH',
  },
  {
    id: 'SNB971345683381',
    name: 'Stadtwerke Wolmirstedt GmbH',
  },
  {
    id: 'SNB935626894156',
    name: 'Stadtwerke Zeil a. Main',
  },
  {
    id: 'SNB980783618473',
    name: 'Stadtwerke Zeven GmbH',
  },
  {
    id: 'SNB931316685899',
    name: 'Stadtwerke Zirndorf GmbH',
  },
  {
    id: 'SNB959966681252',
    name: 'Stadtwerke Zittau GmbH',
  },
  {
    id: 'SNB923190544898',
    name: 'Stadtwerke Zweibrücken GmbH',
  },
  {
    id: 'SNB924332586844',
    name: 'Stadtwerke Zwiesel',
  },
  {
    id: 'SNB989679144355',
    name: 'star.Energiewerke GmbH & Co. KG',
  },
  {
    id: 'SNB964045995373',
    name: 'Strom- und Gasnetz Wismar GmbH',
  },
  {
    id: 'SNB930709120863',
    name: 'Stadtwerke Versmold GmbH',
  },
  {
    id: 'SNB981122608278',
    name: 'Stromkontor Netzgesellschaft mbH',
  },
  {
    id: 'SNB933869654360',
    name: 'Stromkontor Rostock Port GmbH',
  },
  {
    id: 'SNB979269087643',
    name: 'Stromnetz Berlin GmbH',
  },
  {
    id: 'SNB968295079586',
    name: 'Stromnetz Hamburg GmbH',
  },
  {
    id: 'SNB947514936855',
    name: 'Stromnetz Kulmbach GmbH & Co. KG',
  },
  {
    id: 'SNB986482940686',
    name: 'Stromnetz Weiden i.d.OPf. GmbH & Co. KG',
  },
  {
    id: 'SNB934214092950',
    name: 'Stromnetzgesellschaft Hechingen GmbH & Co. KG',
  },
  {
    id: 'SNB948673048298',
    name: 'Stromnetzgesellschaft Herrenberg mbH & Co. KG',
  },
  {
    id: 'SNB981460842488',
    name: 'Stromversorgung Angermünde GmbH',
  },
  {
    id: 'SNB939431117011',
    name: 'Stromversorgung Inzell eG',
  },
  {
    id: 'SNB911969765803',
    name: 'Stromversorgung Neunkirchen GmbH',
  },
  {
    id: 'SNB916151866986',
    name: 'Stromversorgung Pfaffenhofen a. d. Ilm GmbH & Co. KG',
  },
  {
    id: 'SNB987795519491',
    name: 'Stromversorgung Röttenbach',
  },
  {
    id: 'SNB955248518643',
    name: 'Stromversorgung Schierling eG',
  },
  {
    id: 'SNB941555074781',
    name: 'Stromversorgung Seebruck eG',
  },
  {
    id: 'SNB998265950638',
    name: 'Stromversorgung Stadtwerke Garbsen GmbH & Co.',
  },
  {
    id: 'SNB954776773166',
    name: 'Stromversorgung Sulz am Neckar GmbH',
  },
  {
    id: 'SNB918539636471',
    name: 'Stromversorgung Zerbst GmbH & Co. KG',
  },
  {
    id: 'SNB984334051054',
    name: 'strotög GmbH Strom für Töging',
  },
  {
    id: 'SNB971199523673',
    name: 'StWB Stadtwerke Brandenburg an der Havel GmbH & Co. KG',
  },
  {
    id: 'SNB957209230809',
    name: 'StWL Städtische Werke Lauf a.d. Pegnitz GmbH',
  },
  {
    id: 'SNB968862623211',
    name: 'SÜC Energie und H²O GmbH',
  },
  {
    id: 'SNB983964953738',
    name: 'SVH Stromversorgung Haar GmbH',
  },
  {
    id: 'SNB919067474511',
    name: 'SVI - Stromversorgung Ismaning GmbH',
  },
  {
    id: 'SNB946885311919',
    name: 'SVS-Versorgungsbetriebe GmbH',
  },
  {
    id: 'SNB918516395612',
    name: 'SWB Netz GmbH',
  },
  {
    id: 'SNB928340368768',
    name: 'SWB Stadtwerke Biedenkopf GmbH',
  },
  {
    id: 'SNB968273674970',
    name: 'SWE Netz GmbH (Ettlingen)',
  },
  {
    id: 'SNB950262883869',
    name: 'SWE Netz GmbH (Erfurt)',
  },
  {
    id: 'SNB982394830312',
    name: 'SWK Stadtwerke Kaiserslautern Versorgungs-AG',
  },
  {
    id: 'SNB973742186519',
    name: 'SWKiel Netz GmbH',
  },
  {
    id: 'SNB930325069232',
    name: 'SWL Übertragungsnetzgesellschaft mbH',
  },
  {
    id: 'SNB989766685099',
    name: 'SWL-energis Netzgesellschaft mbH & Co. KG',
  },
  {
    id: 'SNB969473762610',
    name: 'SWM Infrastruktur GmbH & Co. KG',
  },
  {
    id: 'SNB947270211210',
    name: 'SWN Stadtwerke Neustadt GmbH',
  },
  {
    id: 'SNB943662886851',
    name: 'SWO Netz GmbH',
  },
  {
    id: 'SNB929168402344',
    name: 'SWP Stadtwerke Pforzheim GmbH & Co. KG',
  },
  {
    id: 'SNB981113965977',
    name: 'SWR Energie GmbH & Co. KG',
  },
  {
    id: 'SNB915638224585',
    name: 'SWS Netze GmbH',
  },
  {
    id: 'SNB969362778135',
    name: 'SWS Netze Solingen GmbH',
  },
  {
    id: 'SNB931164620455',
    name: 'SWV Regional GmbH',
  },
  {
    id: 'SNB967812386411',
    name: 'SWW Wunsiedel GmbH',
  },
  {
    id: 'SNB918250928893',
    name: 'Syna GmbH',
  },
  {
    id: 'SNB974739102161',
    name: 'T.W.O. Technische Werke Osning GmbH',
  },
  {
    id: 'SNB978071940108',
    name: 'Technische Werke Naumburg GmbH',
  },
  {
    id: 'SNB970821959712',
    name: 'TEN Thüringer Energienetze GmbH & Co. KG',
  },
  {
    id: 'SNB944835186174',
    name: 'TenneT Offshore 1. Beteiligungsgesellschaft mbH',
  },
  {
    id: 'SNB976089191796',
    name: 'TenneT Offshore 9. Beteiligungsgesellschaft mbH',
  },
  {
    id: 'SNB970033313272',
    name: 'TenneT TSO GmbH',
  },
  {
    id: 'SNB910696207785',
    name: 'Teutoburger Energie Netzwerk eG (TEN eG)',
  },
  {
    id: 'SNB990887002092',
    name: 'Thüga Energienetze GmbH',
  },
  {
    id: 'SNB986916159257',
    name: 'thyssenkrupp Steel Europe AG',
  },
  {
    id: 'SNB984944755380',
    name: 'TransnetBW GmbH',
  },
  {
    id: 'SNB985414225433',
    name: 'TRIDELTA Energieversorgungs GmbH',
  },
  {
    id: 'SNB960870549385',
    name: 'TWL-Verteilnetz GmbH',
  },
  {
    id: 'SNB977095880292',
    name: 'TWS Netz GmbH',
  },
  {
    id: 'SNB972264483465',
    name: 'Überlandwerk Eppler GmbH',
  },
  {
    id: 'SNB957632855181',
    name: 'Überlandwerk Erding GmbH & Co. KG',
  },
  {
    id: 'SNB910956210043',
    name: 'Überlandwerk Leinetal GmbH',
  },
  {
    id: 'SNB936940951426',
    name: 'Überlandwerk Rhön GmbH',
  },
  {
    id: 'SNB917454122557',
    name: 'Überlandzentrale Wörth/I.-Altheim Netz AG',
  },
  {
    id: 'SNB929185184919',
    name: 'Unterfränkische Überlandzentrale eG',
  },
  {
    id: 'SNB933760214908',
    name: 'Veolia Industriepark Deutschland GmbH',
  },
  {
    id: 'SNB932161540975',
    name: 'Verbandsgemeindewerke Enkenbach-Alsenborn',
  },
  {
    id: 'SNB931064958931',
    name: 'Vereinigte Stadtwerke Netz GmbH',
  },
  {
    id: 'SNB966808200267',
    name: 'Vereinigte Wertach Elektrizitätswerke GmbH',
  },
  {
    id: 'SNB982713229933',
    name: 'Versorgungsbetrieb Waldbüttelbrunn GmbH',
  },
  {
    id: 'SNB973519584647',
    name: 'Versorgungsbetriebe Bordesholm GmbH',
  },
  {
    id: 'SNB971770548286',
    name: 'VersorgungsBetriebe Elbe GmbH',
  },
  {
    id: 'SNB917574266223',
    name: 'Versorgungsbetriebe Hann. Münden GmbH',
  },
  {
    id: 'SNB946612539746',
    name: 'Versorgungsbetriebe Hoyerswerda GmbH',
  },
  {
    id: 'SNB934967462406',
    name: 'Versorgungsbetriebe Kronshagen GmbH',
  },
  {
    id: 'SNB911104987275',
    name: 'Versorgungsbetriebe Röttingen',
  },
  {
    id: 'SNB929840763916',
    name: 'VersorgungsWerke Heddesheim GmbH & Co. KG',
  },
  {
    id: 'SNB977641826996',
    name: 'Verteilnetz Plauen GmbH',
  },
  {
    id: 'SNB940122004213',
    name: 'Verteilnetze Energie Weißenhorn GmbH & Co. KG',
  },
  {
    id: 'SNB921393645589',
    name: 'VHH Netz GmbH & Co. KG',
  },
  {
    id: 'SNB964630351430',
    name: 'Vorarlberger Energienetze GmbH',
  },
  {
    id: 'SNB941650885558',
    name: 'VSE Verteilnetz GmbH',
  },
  {
    id: 'SNB978865527096',
    name: 'VW KRAFTWERK Gesellschaft mit beschränkter Haftung',
  },
  {
    id: 'SNB971169136186',
    name: 'Weißachtal-Kraftwerke eG',
  },
  {
    id: 'SNB928759560869',
    name: 'WEMAG Netz GmbH',
  },
  {
    id: 'SNB946373984786',
    name: 'Wendelsteinbahn Verteilnetz GmbH',
  },
  {
    id: 'SNB973501936539',
    name: 'Werraenergie GmbH',
  },
  {
    id: 'SNB942238573102',
    name: 'wesernetz Bremen GmbH',
  },
  {
    id: 'SNB985704986426',
    name: 'wesernetz Bremerhaven GmbH',
  },
  {
    id: 'SNB979973883449',
    name: 'Westenthanner Energieversorgung GmbH',
  },
  {
    id: 'SNB929881052512',
    name: 'Westfalen Weser Netz GmbH',
  },
  {
    id: 'SNB921897286493',
    name: 'Westnetz GmbH',
  },
  {
    id: 'SNB969345305204',
    name: 'WEV Warendorfer Energieversorgung GmbH',
  },
  {
    id: 'SNB914508596067',
    name: 'WiDe Flex Bau + Service GmbH',
  },
  {
    id: 'SNB919649671758',
    name: 'Wirtschaftsbetriebe der Stadt Norden GmbH',
  },
  {
    id: 'SNB931610892481',
    name: 'Wirtschaftsbetriebe der Stadt NSHB Borkum GmbH',
  },
  {
    id: 'SNB914306944756',
    name: 'WSW Netz GmbH',
  },
  {
    id: 'SNB925823629552',
    name: 'Zwickauer Energieversorgung GmbH',
  },
  {
    id: 'SNB936461984224',
    name: 'Stadtwerke Schönebeck GmbH - SWS -',
  },
  {
    id: 'SNB940436967099',
    name: 'Gemeindewerke Niefern-Öschelbronn',
  },
  {
    id: 'SNB952677840789',
    name: 'Stadtwerke Heilbad Heiligenstadt GmbH',
  },
  {
    id: 'SNB955706777742',
    name: 'Gemeindewerke Lam',
  },
  {
    id: 'SNB967148688999',
    name: 'SWL Verteilungsnetzgesellschaft mbH',
  },
  {
    id: 'SNB956986612075',
    name: 'Saerbecker Ver- und Entsorgungsnetzgesellschaft mbH',
  },
  {
    id: 'SNB977535807001',
    name: 'Infraserv Netze GmbH',
  },
  {
    id: 'SNB958077102830',
    name: 'swa Netze GmbH',
  },
  {
    id: 'SNB974693983233',
    name: 'EVIP GmbH',
  },
  {
    id: 'SNB922722422505',
    name: 'AlzChem Netz GmbH',
  },
  {
    id: 'SNB906862380628',
    name: 'Mittelhessen Netz GmbH',
  },
  {
    id: 'SNB944323025954',
    name: 'Hafenbetriebs- und Entwicklungsgesellschaft Sassnitz mbH',
  },
  {
    id: 'SNB942182027607',
    name: 'DB Energie GmbH',
  },
  {
    id: 'SNB926442995943',
    name: 'Stadtwerke Greifswald GmbH',
  },
  {
    id: 'SNB970734009313',
    name: 'TenneT Offshore DolWin3 GmbH & Co. KG',
  },
  {
    id: 'SNB910224319560',
    name: 'Weiler Wärme eG',
  },
  {
    id: 'SNB930525911119',
    name: 'EGC Infrastruktur und Netz GmbH',
  },
  {
    id: 'SNB975061261090',
    name: 'Stauferwerk  GmbH & Co. KG',
  },
  {
    id: 'SNB991263248615',
    name: 'Stadtwerke Vlotho Stromnetz GmbH',
  },
  {
    id: 'SNB920393062051',
    name: 'NordNetz GmbH',
  },
  {
    id: 'SNB980362940834',
    name: 'Stromnetz24 GmbH',
  },
  {
    id: 'SNB903808877785',
    name: 'Stromnetz Pullach GmbH',
  },
  {
    id: 'SNB931639626302',
    name: 'Stadtwerke Hemer GmbH',
  },
  {
    id: 'SNB900123507953',
    name: 'Stadtwerke Steinfurt GmbH',
  },
  {
    id: 'SNB978108787379',
    name: 'NHL Netzgesellschaft Heilbronner Land GmbH & Co. KG',
  },
  {
    id: 'SNB911692402044',
    name: 'Stadtwerke Warburg GmbH',
  },
  {
    id: 'SNB974711150357',
    name: 'NETCUR GmbH',
  },
  {
    id: 'SNB956923775696',
    name: 'CPM Netz GmbH',
  },
  {
    id: 'SNB950039201827',
    name: 'Stadtwerke Lehrte GmbH',
  },
  {
    id: 'SNB964802985821',
    name: 'Stadtwerke Röthenbach a. d. Pegnitz GmbH',
  },
  {
    id: 'SNB983315496327',
    name: 'Ahrtal-Werke GmbH',
  },
  {
    id: 'SNB971503120734',
    name: 'Stadtwerke Service Meerbusch Willich GmbH & Co. KG',
  },
  {
    id: 'SNB942224012479',
    name: 'Holy AG',
  },
  {
    id: 'SNB940133714842',
    name: 'Creos Deutschland GmbH',
  },
  {
    id: 'SNB939191427887',
    name: 'Gelsenkirchen Raffinerie Netz GmbH',
  },
  {
    id: 'SNB914273329792',
    name: 'Stadtwerke Rastatt',
  },
  {
    id: 'SNB974053451990',
    name: 'Kommunalunternehmen Leutershausen',
  },
  {
    id: 'SNB918100919279',
    name: 'GIG energy services GmbH',
  },
  {
    id: 'SNB916731523131',
    name: 'Baltic Cable AB',
  },
  {
    id: 'SNB972578669388',
    name: 'Quartier Bernsteinsee GmbH',
  },
  {
    id: 'SNB947592865054',
    name: 'Stuttgart Netze GmbH',
  },
  {
    id: 'SNB977451702473',
    name: 'Stromkontor Griesheim GmbH',
  },
  {
    id: 'SNB990892864395',
    name: 'Stadtwerke Ditzingen',
  },
  {
    id: 'SNB910395619643',
    name: 'Blomberg Netz GmbH & Co. KG',
  },
  {
    id: 'SNB952845016893',
    name: 'LeineNetz GmbH',
  },
];

export const GRID_OPERATORS_DE: GridOperator[] = dedupeOperators(
  gridOperatorsDe
).toSorted((a, b) => a.name.localeCompare(b.name));

export const GRID_OPERATORS_BOTH: GridOperator[] = dedupeOperators([
  ...GRID_OPERATORS_DE,
  ...GRID_OPERATORS_AT,
]).toSorted((a, b) => a.name.localeCompare(b.name));
